<template>
    <v-form ref="refMain" v-if="dPriAlumno">
        <v-card>
            <v-card-text class="pb-0" fluid>
                <v-row>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-select v-model="dPriAlumno.tipo_documento" label="* Tipo Documento" :items="[{text: 'DNI', value: 1},{text: 'Carnet Extranjeria', value: 2}]" :disabled="dLoading" filled :rules="[v => !!v || 'El campo es requerido']"></v-select>
                    </v-col>
                    <v-col cols="12" xm="12" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.DNI" label="*Numero" :disabled="dIsReadOnly" filled prepend-inner-icon="credit_card" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= cNroDocSizeMax) || 'El campo debe ser <= a '+cNroDocSizeMax+' caracteres.']" type="number" clearable counter></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.ApPaterno" label="*Apellido Paterno" :disabled="dIsReadOnly" filled prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.ApMaterno" label="*Apellido Materno" :disabled="dIsReadOnly" filled prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.Nombres" label="*Nombres" :disabled="dIsReadOnly" filled prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-select v-model="dPriAlumno.Sexo" label="*Sexo" :items="[{text: 'Femenino', value: 'F'},
                                    {text: 'Masculino', value: 'M'}]" :disabled="dLoading" filled prepend-inner-icon="wc" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-menu
                            ref="refMenu"
                            v-model="dDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="dFecNac"
                                label="*F. Nacimiento"
                                :messages="cEdad"
                                prepend-inner-icon="event_note"
                                readonly
                                filled
                                :disabled="dLoading"
                                v-on="on"
                                :rules="[v => !!v || 'El campo es requerido']"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="dFecNac"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                                @change="fuDateChange"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.Celular" label="*Celular" :disabled="dLoading" filled prepend-inner-icon="smartphone" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.Telefono" label="Teléfono" :disabled="dLoading" filled prepend-inner-icon="phone" :maxlength="10" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.Email" label="Correo Electrónico" :disabled="dLoading" filled prepend-inner-icon="email" :maxlength="100" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="4" class="pa-1">
                        <v-text-field v-model="dPriAlumno.Direccion" label="Dirección - Referencia" :disabled="dLoading" filled prepend-inner-icon="location_on" :maxlength="80" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="4" class="pa-1">
                        <v-autocomplete
                            v-model="dPriAlumno.UbigeoD" label="Ubigeo de Referencia"
                            :items=dUbigeos
                            :disabled="dLoading" filled clearable prepend-inner-icon="location_on">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="4" class="pa-1">
                        <v-autocomplete
                            v-model="dPriAlumno.UbigeoN" label="Ubigeo de Nacimiento"
                            :items=dUbigeos
                            :disabled="dLoading" filled clearable prepend-inner-icon="location_on">
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-title class="py-2" style="background:#E3F2FD">
                <v-icon left>school</v-icon> <span>Académico</span>
            </v-card-title>
            <v-card-text class="pb-0" fluid>
                <v-row>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-select v-model="dPriAlumno.QuienEligioCarrera" label="¿Quien eligió su profesión?"
                            :items="['Yo', 'Mis Padres', 'Mis Hermanos', 'Mis Familiares', 'Otros']" :disabled="dLoading" filled prepend-inner-icon="face" :rules="[v => !!v || 'El campo es requerido']">
                        </v-select>
                    </v-col>
                    <v-col cols="12" xm="12" sm="6" md="9" class="pa-1">
                        <v-dialog v-model="dPriColegioModal.dialog" persistent max-width="1000px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" v-on="on" @click:append="dPriColegioModal.dialog = true"
                                    v-model="dPriColegioText" label="Colegio"
                                    readonly filled prepend-inner-icon="home" append-icon="search"
                                ></v-text-field>
                            </template>
                            <v-card>
                                <v-card-title style="background-color:#455A64">
                                    <v-form ref="refPriColegio">
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6" lg="6" class="pa-0">
                                                <v-text-field v-model="dPriColegio.Nombre" label="Colegio" prepend-inner-icon="home" outlined clearable :rules="[v => !!v || 'El campo es requerido']" autocomplete="off" dark></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="5" md="4" lg="4" class="pa-0">
                                                <v-select v-model="dPriColegio.Dpto" label="Departamento" :items="dPriColegioDepartamento" outlined prepend-inner-icon="location_on" :rules="[v => !!v || 'El campo es requerido']" dark></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="1" md="2" lg="2" class="pa-0">
                                                <v-btn @click.prevent="fuPriColegioSearch" :loading="dPriColegioModal.loading" color="blue-grey" dark x-large><v-icon>search</v-icon></v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card-title>
                                <v-data-table
                                    v-model="dPriColegioTable.selected"
                                    :headers="dPriColegioTable.headers"
                                    :items="dPriColegios"
                                    :loading="dPriColegioModal.loading"
                                    single-select
                                    item-key="IdColegio"
                                    show-select
                                    class="elevation-1">
                                    <template v-slot:[`item.Dpto`]="{ item }">
                                        <v-chip color="success" dark>{{item.Dpto+"/"+item.Provincia+"/"+item.Distrito}}</v-chip>
                                    </template>
                                </v-data-table>
                                <v-card-actions class="blue-grey darken-2">
                                    <v-btn @click="fuPriColegioSelected()" color="green" dark><v-icon>check</v-icon> Seleccionar</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="dPriColegioModal.dialog = false" color="grey darken-4" dark><v-icon>close</v-icon> Cerrar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-autocomplete v-model="dPriAlumno.AnioEgresoSecundaria" label="Año que egreso"
                            :items="dYears"
                            :disabled="dLoading" filled prepend-inner-icon="event_note"></v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-title class="py-2" style="background:#E3F2FD">
                <v-icon left>paid</v-icon> <span>Económico</span>
            </v-card-title>
            <v-card-text class="pb-0" fluid>
                <v-row>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-autocomplete v-model="dPriAlumno.DependeEco" label="Dependencia Económica"
                            :items="['Padre', 'Madre', 'Hermano', 'Conyuge', 'Independiente', 'Otros']"
                            :disabled="dLoading" filled prepend-inner-icon="wc">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-select v-model="dPriAlumno.TipoTrabajo" label="Tipo de Trabajo"
                            :items="['Dependiente', 'Independiente']"
                            :disabled="dLoading" filled prepend-inner-icon="business_center">
                        </v-select>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-autocomplete v-model="dPriAlumno.Ocupacion" label="Ocupación"
                            :items="['Actividad Artesanal',
                                'Actividades agrícolas, silvícolas',
                                'Actividades ganaderas, de caza y pesca',
                                'Administrador',
                                'ALBAÑIL / CONSTRUCCION / GASFITERO',
                                'ASISTENTE ADMINISTRATIVO / GERENCIA',
                                'ATENCION AL CLIENTE / INTERNET',
                                'AYUDANTE CASA / ENFERMERIA / NIÑERA',
                                'BARMAN / COCINA / MOZO',
                                'CAJERO / CAMBISTA / PAGADOR',
                                'COMERCIANTE / EMPRESARIO',
                                'CONDUCTOR',
                                'DISEÑO GRAFICO / WEB',
                                'DOCENTE',
                                'FF.AA. y PP',
                                'HOUSEKEEPING / RECEPCIONISTA / GUIA',
                                'INDEPENDIENTE',
                                'MUSICO',
                                'Obreros',
                                'Operadores de maquinaria',
                                'OTROS',
                                'PROMOTOR / SUPERVISOR / CONTRATISTA',
                                'Servicios de protección y vigilancia',
                                'Técnico']" :disabled="dLoading" filled prepend-inner-icon="school">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-select v-model="dPriAlumno.IngresoMensual" label="Ingreso Mensual"
                            :items="['De 501 a 800', 'De 801 a 1000', 'De 1001 a 1500', 'De 1501 a más']"
                            :disabled="dLoading" filled prepend-inner-icon="monetization_on">
                        </v-select>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.CentroTrabajo" label="Centro de Trabajo" :disabled="dLoading" filled prepend-inner-icon="apartment" :maxlength="50" autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                        <v-text-field v-model="dPriAlumno.DireccionTrabajo" label="Dirección de Trabajo" :disabled="dLoading" filled prepend-inner-icon="location_on" :maxlength="50" autocomplete="off"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="blue-grey darken-1">
                <v-btn @click.prevent="fuAlumnoSave" :loading="dLoading" color="primary"><v-icon>save</v-icon>Guardar</v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-form>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    name: 'AlumnoItem',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    mounted(){
        let today = new Date();        
        for (var i = today.getFullYear(); i >= today.getFullYear()-70; i--) {
            this.dYears.push(i);
        }
        if (this.pIdAlumno)
            this.fuAlumno(this.pIdAlumno);
    },
    data: () => ({
        dSnackbar: false,
        dLoading: false,
        dIsReadOnly: false,
        dDateMenu: false,
        dFecNac: '',
        dDNI: '',
        dApPaterno: '',
        dApMaterno: '',
        dNombres: '',
        dPriAlumno: null,
        dYears: [],
        dPriColegio: {
            Nombre:'',
            Dpto: 'Cusco'
        },
        dPriColegioText: '',
        dPriColegios: [],
        dPriColegioModal: {
            dialog: false,
            loading: false,
        },
        dPriColegioTable: {
            headers: [
                {value: 'IdColegio', text: 'Codigo'},
                {value: 'Nombre', text: 'Nombre'},
                {value: 'Modalidad', text: 'Modalidad'},
                {value: 'TipoColegio', text: 'Tipo'},
                {value: 'Dpto', text: 'Ubigeo'}
            ],
            selected: []
        },
        dPriColegioDepartamento: [
            'Amazonas',
            'Ancash',
            'Apurimac',
            'Arequipa',
            'Ayacucho',
            'Cajamarca',
            'Callao',
            'Cusco',
            'Huancavelica',
            'Huanuco',
            'Ica',
            'Junin',
            'La Libertad',
            'Lambayeque',
            'Lima',
            'Loreto',
            'Madre de Dios',
            'Moquegua',
            'Otros',
            'Pasco',
            'Piura',
            'Puno',
            'San Martin',
            'Tacna',
            'Tumbes',
            'Ucayali',
        ],
        dUbigeos: [
{text: 'VENEZUELA/VENEZUELA/VENEZUELA', value: '000001'},
{text: 'AMAZONAS/BAGUA/ARAMANGO', value: '010202'}, 
{text: 'AMAZONAS/BAGUA/BAGUA', value: '010205'}, 
{text: 'AMAZONAS/BAGUA/COPALLIN', value: '010203'}, 
{text: 'AMAZONAS/BAGUA/EL PARCO', value: '010204'}, 
{text: 'AMAZONAS/BAGUA/IMAZA', value: '010206'}, 
{text: 'AMAZONAS/BAGUA/LA PECA', value: '010201'}, 
{text: 'AMAZONAS/BONGARA/CHISQUILLA', value: '010304'}, 
{text: 'AMAZONAS/BONGARA/CHURUJA', value: '010305'}, 
{text: 'AMAZONAS/BONGARA/COROSHA', value: '010302'}, 
{text: 'AMAZONAS/BONGARA/CUISPES', value: '010303'}, 
{text: 'AMAZONAS/BONGARA/FLORIDA', value: '010306'}, 
{text: 'AMAZONAS/BONGARA/JAZAN', value: '010312'}, 
{text: 'AMAZONAS/BONGARA/JUMBILLA', value: '010301'}, 
{text: 'AMAZONAS/BONGARA/RECTA', value: '010307'}, 
{text: 'AMAZONAS/BONGARA/SAN CARLOS', value: '010308'}, 
{text: 'AMAZONAS/BONGARA/SHIPASBAMBA', value: '010309'}, 
{text: 'AMAZONAS/BONGARA/VALERA', value: '010310'}, 
{text: 'AMAZONAS/BONGARA/YAMBRASBAMBA', value: '010311'}, 
{text: 'AMAZONAS/CHACHAPOYAS/ASUNCION', value: '010102'}, 
{text: 'AMAZONAS/CHACHAPOYAS/BALSAS', value: '010103'}, 
{text: 'AMAZONAS/CHACHAPOYAS/CHACHAPOYAS', value: '010101'}, 
{text: 'AMAZONAS/CHACHAPOYAS/CHETO', value: '010104'}, 
{text: 'AMAZONAS/CHACHAPOYAS/CHILIQUIN', value: '010105'}, 
{text: 'AMAZONAS/CHACHAPOYAS/CHUQUIBAMBA', value: '010106'}, 
{text: 'AMAZONAS/CHACHAPOYAS/GRANADA', value: '010107'}, 
{text: 'AMAZONAS/CHACHAPOYAS/HUANCAS', value: '010108'}, 
{text: 'AMAZONAS/CHACHAPOYAS/LA JALCA', value: '010109'}, 
{text: 'AMAZONAS/CHACHAPOYAS/LEIMEBAMBA', value: '010110'}, 
{text: 'AMAZONAS/CHACHAPOYAS/LEVANTO', value: '010111'}, 
{text: 'AMAZONAS/CHACHAPOYAS/MAGDALENA', value: '010112'}, 
{text: 'AMAZONAS/CHACHAPOYAS/MARISCAL CASTILLA', value: '010113'}, 
{text: 'AMAZONAS/CHACHAPOYAS/MOLINOPAMPA', value: '010114'}, 
{text: 'AMAZONAS/CHACHAPOYAS/MONTEVIDEO', value: '010115'}, 
{text: 'AMAZONAS/CHACHAPOYAS/OLLEROS', value: '010116'}, 
{text: 'AMAZONAS/CHACHAPOYAS/QUINJALCA', value: '010117'}, 
{text: 'AMAZONAS/CHACHAPOYAS/SAN FCO DE DAGUAS', value: '010118'}, 
{text: 'AMAZONAS/CHACHAPOYAS/SAN ISIDRO DE MAINO', value: '010119'}, 
{text: 'AMAZONAS/CHACHAPOYAS/SOLOCO', value: '010120'}, 
{text: 'AMAZONAS/CHACHAPOYAS/SONCHE', value: '010121'}, 
{text: 'AMAZONAS/CONDORCANQUI/EL CENEPA', value: 'NULL'}, 
{text: 'AMAZONAS/CONDORCANQUI/EL CENEPA', value: '010603'}, 
{text: 'AMAZONAS/CONDORCANQUI/NIEVA', value: '010601'}, 
{text: 'AMAZONAS/CONDORCANQUI/NIEVA', value: 'NULL'}, 
{text: 'AMAZONAS/CONDORCANQUI/RIO SANTIAGO', value: 'NULL'}, 
{text: 'AMAZONAS/CONDORCANQUI/RIO SANTIAGO', value: '010602'}, 
{text: 'AMAZONAS/LUYA/CAMPORREDONDO', value: '010402'}, 
{text: 'AMAZONAS/LUYA/COCABAMBA', value: '010403'}, 
{text: 'AMAZONAS/LUYA/COLCAMAR', value: '010404'}, 
{text: 'AMAZONAS/LUYA/CONILA', value: '010405'}, 
{text: 'AMAZONAS/LUYA/INGUILPATA', value: '010406'}, 
{text: 'AMAZONAS/LUYA/LAMUD', value: '010401'}, 
{text: 'AMAZONAS/LUYA/LONGUITA', value: '010407'}, 
{text: 'AMAZONAS/LUYA/LONYA CHICO', value: '010408'}, 
{text: 'AMAZONAS/LUYA/LUYA', value: '010409'}, 
{text: 'AMAZONAS/LUYA/LUYA VIEJO', value: '010410'}, 
{text: 'AMAZONAS/LUYA/MARIA', value: '010411'}, 
{text: 'AMAZONAS/LUYA/OCALLI', value: '010412'}, 
{text: 'AMAZONAS/LUYA/OCUMAL', value: '010413'}, 
{text: 'AMAZONAS/LUYA/PISUQUIA', value: '010414'}, 
{text: 'AMAZONAS/LUYA/PROVIDENCIA', value: '010423'}, 
{text: 'AMAZONAS/LUYA/SAN CRISTOBAL', value: '010415'}, 
{text: 'AMAZONAS/LUYA/SAN FRANCISCO DE YESO', value: '010416'}, 
{text: 'AMAZONAS/LUYA/SAN JERONIMO', value: '010417'}, 
{text: 'AMAZONAS/LUYA/SAN JUAN DE LOPECANCHA', value: '010418'}, 
{text: 'AMAZONAS/LUYA/SANTA CATALINA', value: '010419'}, 
{text: 'AMAZONAS/LUYA/SANTO TOMAS', value: '010420'}, 
{text: 'AMAZONAS/LUYA/TINGO', value: '010421'}, 
{text: 'AMAZONAS/LUYA/TRITA', value: '010422'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/CHIRIMOTO', value: '010503'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/COCHAMAL', value: '010502'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/HUAMBO', value: '010504'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/LIMABAMBA', value: '010505'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/LONGAR', value: '010506'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/MCAL BENAVIDES', value: '010508'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/MILPUC', value: '010507'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/OMIA', value: '010509'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/SAN NICOLAS', value: '010501'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/SANTA ROSA', value: '010510'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/TOTORA', value: '010511'}, 
{text: 'AMAZONAS/RODR-GUEZ DE MENDOZA/VISTA ALEGRE', value: '010512'}, 
{text: 'AMAZONAS/UTCUBAMBA/BAGUA GRANDE', value: '010701'}, 
{text: 'AMAZONAS/UTCUBAMBA/CAJARURO', value: '010702'}, 
{text: 'AMAZONAS/UTCUBAMBA/CUMBA', value: '010703'}, 
{text: 'AMAZONAS/UTCUBAMBA/EL MILAGRO', value: '010704'}, 
{text: 'AMAZONAS/UTCUBAMBA/JAMALCA', value: '010705'}, 
{text: 'AMAZONAS/UTCUBAMBA/LONYA GRANDE', value: '010706'}, 
{text: 'AMAZONAS/UTCUBAMBA/YAMON', value: '010707'}, 
{text: 'ANCASH/AIJA/AIJA', value: '020201'}, 
{text: 'ANCASH/AIJA/CORIS', value: '020203'}, 
{text: 'ANCASH/AIJA/HUACLLAN', value: '020205'}, 
{text: 'ANCASH/AIJA/LA MERCED', value: '020206'}, 
{text: 'ANCASH/AIJA/SUCCHA', value: '020208'}, 
{text: 'ANCASH/ANTONIO RAYMONDI/ACZO', value: '021602'}, 
{text: 'ANCASH/ANTONIO RAYMONDI/CHACCHO', value: '021603'}, 
{text: 'ANCASH/ANTONIO RAYMONDI/CHINGAS', value: '021604'}, 
{text: 'ANCASH/ANTONIO RAYMONDI/LLAMELLIN', value: '021601'}, 
{text: 'ANCASH/ANTONIO RAYMONDI/MIRGAS', value: '021605'}, 
{text: 'ANCASH/ANTONIO RAYMONDI/SAN JUAN DE RONTOY', value: '021606'}, 
{text: 'ANCASH/ASUNCION/ACOCHACA', value: '021802'}, 
{text: 'ANCASH/ASUNCION/CHACAS', value: '021801'}, 
{text: 'ANCASH/BOLOGNESI/A PARDO LEZAMETA', value: '020302'}, 
{text: 'ANCASH/BOLOGNESI/ANTONIO RAIMONDI', value: '020321'}, 
{text: 'ANCASH/BOLOGNESI/AQUIA', value: '020304'}, 
{text: 'ANCASH/BOLOGNESI/CAJACAY', value: '020305'}, 
{text: 'ANCASH/BOLOGNESI/CANIS', value: '020322'}, 
{text: 'ANCASH/BOLOGNESI/CHIQUIAN', value: '020301'}, 
{text: 'ANCASH/BOLOGNESI/COLQUIOC', value: '020323'}, 
{text: 'ANCASH/BOLOGNESI/HUALLANCA', value: '020325'}, 
{text: 'ANCASH/BOLOGNESI/HUASTA', value: '020311'}, 
{text: 'ANCASH/BOLOGNESI/HUAYLLACAYAN', value: '020310'}, 
{text: 'ANCASH/BOLOGNESI/LA PRIMAVERA', value: '020324'}, 
{text: 'ANCASH/BOLOGNESI/MANGAS', value: '020313'}, 
{text: 'ANCASH/BOLOGNESI/PACLLON', value: '020315'}, 
{text: 'ANCASH/BOLOGNESI/SAN MIGUEL DE CORPANQUI', value: '020317'}, 
{text: 'ANCASH/BOLOGNESI/TICLLOS', value: '020320'}, 
{text: 'ANCASH/CARHUAZ/ACOPAMPA', value: '020402'}, 
{text: 'ANCASH/CARHUAZ/AMASHCA', value: '020403'}, 
{text: 'ANCASH/CARHUAZ/ANTA', value: '020404'}, 
{text: 'ANCASH/CARHUAZ/ATAQUERO', value: '020405'}, 
{text: 'ANCASH/CARHUAZ/CARHUAZ', value: '020401'}, 
{text: 'ANCASH/CARHUAZ/MARCARA', value: '020406'}, 
{text: 'ANCASH/CARHUAZ/PARIAHUANCA', value: '020407'}, 
{text: 'ANCASH/CARHUAZ/SAN MIGUEL DE ACO', value: '020408'}, 
{text: 'ANCASH/CARHUAZ/SHILLA', value: '020409'}, 
{text: 'ANCASH/CARHUAZ/TINCO', value: '020410'}, 
{text: 'ANCASH/CARHUAZ/YUNGAR', value: '020411'}, 
{text: 'ANCASH/CARLOS F. FITZCARRALD/SAN LUIS', value: '021701'}, 
{text: 'ANCASH/CARLOS F. FITZCARRALD/SAN NICOLAS', value: '021703'}, 
{text: 'ANCASH/CARLOS F. FITZCARRALD/YAUYA', value: '021702'}, 
{text: 'ANCASH/CASMA/BUENA VISTA ALTA', value: '020502'}, 
{text: 'ANCASH/CASMA/CASMA', value: '020501'}, 
{text: 'ANCASH/CASMA/COMANDANTE NOEL', value: '020503'}, 
{text: 'ANCASH/CASMA/YAUTAN', value: '020505'}, 
{text: 'ANCASH/CORONGO/ACO', value: '020602'}, 
{text: 'ANCASH/CORONGO/BAMBAS', value: '020603'}, 
{text: 'ANCASH/CORONGO/CORONGO', value: '020601'}, 
{text: 'ANCASH/CORONGO/CUSCA', value: '020604'}, 
{text: 'ANCASH/CORONGO/LA PAMPA', value: '020605'}, 
{text: 'ANCASH/CORONGO/YANAC', value: '020606'}, 
{text: 'ANCASH/CORONGO/YUPAN', value: '020607'}, 
{text: 'ANCASH/HUARAZ/COCHABAMBA', value: '020103'}, 
{text: 'ANCASH/HUARAZ/COLCABAMBA', value: '020104'}, 
{text: 'ANCASH/HUARAZ/HUANCHAY', value: '020105'}, 
{text: 'ANCASH/HUARAZ/HUARAZ', value: '020101'}, 
{text: 'ANCASH/HUARAZ/INDEPENDENCIA', value: '020102'}, 
{text: 'ANCASH/HUARAZ/JANGAS', value: '020106'}, 
{text: 'ANCASH/HUARAZ/LA LIBERTAD', value: '020107'}, 
{text: 'ANCASH/HUARAZ/OLLEROS', value: '020108'}, 
{text: 'ANCASH/HUARAZ/PAMPAS', value: '020109'}, 
{text: 'ANCASH/HUARAZ/PARIACOTO', value: '020109'}, 
{text: 'ANCASH/HUARAZ/PIRA', value: '020111'}, 
{text: 'ANCASH/HUARAZ/TARICA', value: '020112'}, 
{text: 'ANCASH/HUARI/ANRA', value: '020816'}, 
{text: 'ANCASH/HUARI/CAJAY', value: '020802'}, 
{text: 'ANCASH/HUARI/CHAVIN DE HUANTAR', value: '020803'}, 
{text: 'ANCASH/HUARI/HUACACHI', value: '020804'}, 
{text: 'ANCASH/HUARI/HUACCHIS', value: '020806'}, 
{text: 'ANCASH/HUARI/HUACHIS', value: '020805'}, 
{text: 'ANCASH/HUARI/HUANTAR', value: '020807'}, 
{text: 'ANCASH/HUARI/HUARI', value: '020801'}, 
{text: 'ANCASH/HUARI/MASIN', value: '020808'}, 
{text: 'ANCASH/HUARI/PAUCAS', value: '020809'}, 
{text: 'ANCASH/HUARI/PONTO', value: '020810'}, 
{text: 'ANCASH/HUARI/RAHUAPAMPA', value: '020811'}, 
{text: 'ANCASH/HUARI/RAPAYAN', value: '020812'}, 
{text: 'ANCASH/HUARI/SAN MARCOS', value: '020813'}, 
{text: 'ANCASH/HUARI/SAN PEDRO DE CHANA', value: '020814'}, 
{text: 'ANCASH/HUARI/UCO', value: '020815'}, 
{text: 'ANCASH/HUARMEY/COCHAPETI', value: '021902'}, 
{text: 'ANCASH/HUARMEY/CULEBRAS', value: '021905'}, 
{text: 'ANCASH/HUARMEY/HUARMEY', value: '021901'}, 
{text: 'ANCASH/HUARMEY/HUAYAN', value: '021903'}, 
{text: 'ANCASH/HUARMEY/MALVAS', value: '021904'}, 
{text: 'ANCASH/HUAYLAS/CARAZ', value: '020701'}, 
{text: 'ANCASH/HUAYLAS/HUALLANCA', value: '020702'}, 
{text: 'ANCASH/HUAYLAS/HUATA', value: '020703'}, 
{text: 'ANCASH/HUAYLAS/HUAYLAS', value: '020704'}, 
{text: 'ANCASH/HUAYLAS/MATO', value: '020705'}, 
{text: 'ANCASH/HUAYLAS/PAMPAROMAS', value: '020706'}, 
{text: 'ANCASH/HUAYLAS/PUEBLO LIBRE', value: '020707'}, 
{text: 'ANCASH/HUAYLAS/SANTA CRUZ', value: '020708'}, 
{text: 'ANCASH/HUAYLAS/SANTO TORIBIO', value: '020710'}, 
{text: 'ANCASH/HUAYLAS/YURACMARCA', value: '020709'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/CASCA', value: '020902'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/ELEAZAR GUZMAN BARRON', value: '020908'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/FIDEL OLIVAS ESCUDERO', value: '020904'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/LLAMA', value: '020905'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/LLUMPA', value: '020906'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/LUCMA', value: '020903'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/MUSGA', value: '020907'}, 
{text: 'ANCASH/MARISCAL LUZURIAGA/PISCOBAMBA', value: '020901'}, 
{text: 'ANCASH/OCROS/ACAS', value: '022001'}, 
{text: 'ANCASH/OCROS/CAJAMARQUILLA', value: '022002'}, 
{text: 'ANCASH/OCROS/CARHUAPAMPA', value: '022003'}, 
{text: 'ANCASH/OCROS/COCHAS', value: '022004'}, 
{text: 'ANCASH/OCROS/CONGAS', value: '022005'}, 
{text: 'ANCASH/OCROS/LLIPA', value: '022006'}, 
{text: 'ANCASH/OCROS/OCROS', value: '022007'}, 
{text: 'ANCASH/OCROS/SAN CRISTOBAL DE RAJAN', value: '022008'}, 
{text: 'ANCASH/OCROS/SAN PEDRO', value: '022009'}, 
{text: 'ANCASH/OCROS/SANTIAGO DE CHILCAS', value: '022010'}, 
{text: 'ANCASH/PALLASCA/BOLOGNESI', value: '021002'}, 
{text: 'ANCASH/PALLASCA/CABANA', value: '021001'}, 
{text: 'ANCASH/PALLASCA/CONCHUCOS', value: '021003'}, 
{text: 'ANCASH/PALLASCA/HUACASCHUQUE', value: '021004'}, 
{text: 'ANCASH/PALLASCA/HUANDOVAL', value: '021005'}, 
{text: 'ANCASH/PALLASCA/LACABAMBA', value: '021006'}, 
{text: 'ANCASH/PALLASCA/LLAPO', value: '021007'}, 
{text: 'ANCASH/PALLASCA/PALLASCA', value: '021008'}, 
{text: 'ANCASH/PALLASCA/PAMPAS', value: '021009'}, 
{text: 'ANCASH/PALLASCA/SANTA ROSA', value: '021010'}, 
{text: 'ANCASH/PALLASCA/TAUCA', value: '021011'}, 
{text: 'ANCASH/POMABAMBA/HUAYLLAN', value: '021102'}, 
{text: 'ANCASH/POMABAMBA/PAROBAMBA', value: '021103'}, 
{text: 'ANCASH/POMABAMBA/POMABAMBA', value: '021101'}, 
{text: 'ANCASH/POMABAMBA/QUINUABAMBA', value: '021104'}, 
{text: 'ANCASH/RECUAY/CATAC', value: '021210'}, 
{text: 'ANCASH/RECUAY/COTAPARACO', value: '021202'}, 
{text: 'ANCASH/RECUAY/HUAYLLAPAMPA', value: '021203'}, 
{text: 'ANCASH/RECUAY/LLACLLIN', value: '021209'}, 
{text: 'ANCASH/RECUAY/MARCA', value: '021204'}, 
{text: 'ANCASH/RECUAY/PAMPAS CHICO', value: '021205'}, 
{text: 'ANCASH/RECUAY/PARARIN', value: '021206'}, 
{text: 'ANCASH/RECUAY/RECUAY', value: '021201'}, 
{text: 'ANCASH/RECUAY/TAPACOCHA', value: '021207'}, 
{text: 'ANCASH/RECUAY/TICAPAMPA', value: '021208'}, 
{text: 'ANCASH/SANTA/CACERES DEL PERU', value: '021302'}, 
{text: 'ANCASH/SANTA/CHIMBOTE', value: '021301'}, 
{text: 'ANCASH/SANTA/COISHCO', value: '021308'}, 
{text: 'ANCASH/SANTA/MACATE', value: '021303'}, 
{text: 'ANCASH/SANTA/MORO', value: '021304'}, 
{text: 'ANCASH/SANTA/NEPENA', value: '021305'}, 
{text: 'ANCASH/SANTA/NUEVO CHIMBOTE', value: '021309'}, 
{text: 'ANCASH/SANTA/SAMANCO', value: '021306'}, 
{text: 'ANCASH/SANTA/SANTA', value: '021307'}, 
{text: 'ANCASH/SIHUAS/ACOBAMBA', value: '021407'}, 
{text: 'ANCASH/SIHUAS/ALFONSO UGARTE', value: '021402'}, 
{text: 'ANCASH/SIHUAS/CASHAPAMPA', value: '021408'}, 
{text: 'ANCASH/SIHUAS/CHINGALPO', value: '021403'}, 
{text: 'ANCASH/SIHUAS/HUAYLLABAMBA', value: '021404'}, 
{text: 'ANCASH/SIHUAS/QUICHES', value: '021405'}, 
{text: 'ANCASH/SIHUAS/RAGASH', value: '021409'}, 
{text: 'ANCASH/SIHUAS/SAN JUAN', value: '021410'}, 
{text: 'ANCASH/SIHUAS/SICSIBAMBA', value: '021406'}, 
{text: 'ANCASH/SIHUAS/SIHUAS', value: '021401'}, 
{text: 'ANCASH/YUNGAY/CASCAPARA', value: '021502'}, 
{text: 'ANCASH/YUNGAY/MANCOS', value: '021503'}, 
{text: 'ANCASH/YUNGAY/MATACOTO', value: '021504'}, 
{text: 'ANCASH/YUNGAY/QUILLO', value: '021505'}, 
{text: 'ANCASH/YUNGAY/RANRAHIRCA', value: '021506'}, 
{text: 'ANCASH/YUNGAY/SHUPLUY', value: '021507'}, 
{text: 'ANCASH/YUNGAY/YANAMA', value: '021508'}, 
{text: 'ANCASH/YUNGAY/YUNGAY', value: '021501'}, 
{text: 'APURIMAC/ABANCAY/ABANCAY', value: '030101'}, 
{text: 'APURIMAC/ABANCAY/CHACOCHE', value: '030104'}, 
{text: 'APURIMAC/ABANCAY/CIRCA', value: '030102'}, 
{text: 'APURIMAC/ABANCAY/CURAHUASI', value: '030103'}, 
{text: 'APURIMAC/ABANCAY/HUANIPACA', value: '030105'}, 
{text: 'APURIMAC/ABANCAY/LAMBRAMA', value: '030106'}, 
{text: 'APURIMAC/ABANCAY/PICHIRHUA', value: '030107'}, 
{text: 'APURIMAC/ABANCAY/SAN PEDRO DE CACHORA', value: '030108'}, 
{text: 'APURIMAC/ABANCAY/TAMBURCO', value: '030109'}, 
{text: 'APURIMAC/ANDAHUAYLAS/ANDAHUAYLAS', value: '030301'}, 
{text: 'APURIMAC/ANDAHUAYLAS/ANDARAPA', value: '030302'}, 
{text: 'APURIMAC/ANDAHUAYLAS/CHIARA', value: '030303'}, 
{text: 'APURIMAC/ANDAHUAYLAS/HUANCARAMA', value: '030304'}, 
{text: 'APURIMAC/ANDAHUAYLAS/HUANCARAY', value: '030305'}, 
{text: 'APURIMAC/ANDAHUAYLAS/HUAYANA', value: '030317'}, 
{text: 'APURIMAC/ANDAHUAYLAS/KAQUIABAMBA', value: '030319'}, 
{text: 'APURIMAC/ANDAHUAYLAS/KISHUARA', value: '030306'}, 
{text: 'APURIMAC/ANDAHUAYLAS/PACOBAMBA', value: '030307'}, 
{text: 'APURIMAC/ANDAHUAYLAS/PACUCHA', value: '030313'}, 
{text: 'APURIMAC/ANDAHUAYLAS/PAMPACHIRI', value: '030308'}, 
{text: 'APURIMAC/ANDAHUAYLAS/POMACOCHA', value: '030314'}, 
{text: 'APURIMAC/ANDAHUAYLAS/SAN ANTONIO DE CACHI', value: '030309'}, 
{text: 'APURIMAC/ANDAHUAYLAS/SAN JERONIMO', value: '030310'}, 
{text: 'APURIMAC/ANDAHUAYLAS/SAN MIGUEL DE CHACCRAMPA', value: '030318'}, 
{text: 'APURIMAC/ANDAHUAYLAS/STA MARIA DE CHICMO', value: '030315'}, 
{text: 'APURIMAC/ANDAHUAYLAS/TALAVERA', value: '030311'}, 
{text: 'APURIMAC/ANDAHUAYLAS/TUMAY HUARACA', value: '030316'}, 
{text: 'APURIMAC/ANDAHUAYLAS/TURPO', value: '030312'}, 
{text: 'APURIMAC/ANTABAMBA/ANTABAMBA', value: '030401'}, 
{text: 'APURIMAC/ANTABAMBA/EL ORO', value: '030402'}, 
{text: 'APURIMAC/ANTABAMBA/HUAQUIRCA', value: '030403'}, 
{text: 'APURIMAC/ANTABAMBA/JUAN ESPINOZA MEDRANO', value: '030404'}, 
{text: 'APURIMAC/ANTABAMBA/OROPESA', value: '030405'}, 
{text: 'APURIMAC/ANTABAMBA/PACHACONAS', value: '030406'}, 
{text: 'APURIMAC/ANTABAMBA/SABAINO', value: '030407'}, 
{text: 'APURIMAC/AYMARAES/CAPAYA', value: '030202'}, 
{text: 'APURIMAC/AYMARAES/CARAYBAMBA', value: '030203'}, 
{text: 'APURIMAC/AYMARAES/CHALHUANCA', value: '030201'}, 
{text: 'APURIMAC/AYMARAES/CHAPIMARCA', value: '030206'}, 
{text: 'APURIMAC/AYMARAES/COLCABAMBA', value: '030204'}, 
{text: 'APURIMAC/AYMARAES/COTARUSE', value: '030205'}, 
{text: 'APURIMAC/AYMARAES/IHUAYLLO', value: '030207'}, 
{text: 'APURIMAC/AYMARAES/JUSTO APU SAHUARAURA', value: '030217'}, 
{text: 'APURIMAC/AYMARAES/LUCRE', value: '030208'}, 
{text: 'APURIMAC/AYMARAES/POCOHUANCA', value: '030209'}, 
{text: 'APURIMAC/AYMARAES/SAN JUAN DE CHACNA', value: '030216'}, 
{text: 'APURIMAC/AYMARAES/SANAICA', value: '030210'}, 
{text: 'APURIMAC/AYMARAES/SORAYA', value: '030211'}, 
{text: 'APURIMAC/AYMARAES/TAPAIRIHUA', value: '030212'}, 
{text: 'APURIMAC/AYMARAES/TINTAY', value: '030213'}, 
{text: 'APURIMAC/AYMARAES/TORAYA', value: '030214'}, 
{text: 'APURIMAC/AYMARAES/YANACA', value: '030215'}, 
{text: 'APURIMAC/CHINCHEROS/ANCO HUALLO', value: '030705'}, 
{text: 'APURIMAC/CHINCHEROS/CHINCHEROS', value: '030701'}, 
{text: 'APURIMAC/CHINCHEROS/COCHARCAS', value: '030704'}, 
{text: 'APURIMAC/CHINCHEROS/HUACCANA', value: '030706'}, 
{text: 'APURIMAC/CHINCHEROS/OCOBAMBA', value: '030703'}, 
{text: 'APURIMAC/CHINCHEROS/ONGOY', value: '030702'}, 
{text: 'APURIMAC/CHINCHEROS/RANRACANCHA', value: '030708'}, 
{text: 'APURIMAC/CHINCHEROS/URANMARCA', value: '030707'}, 
{text: 'APURIMAC/COTABAMBAS/CHALLHUAHUACHO', value: '030506'}, 
{text: 'APURIMAC/COTABAMBAS/COTABAMBAS', value: '030503'}, 
{text: 'APURIMAC/COTABAMBAS/COYLLURQUI', value: '030502'}, 
{text: 'APURIMAC/COTABAMBAS/HAQUIRA', value: '030504'}, 
{text: 'APURIMAC/COTABAMBAS/MARA', value: '030505'}, 
{text: 'APURIMAC/COTABAMBAS/TAMBOBAMBA', value: '030501'}, 
{text: 'APURIMAC/GRAU/CHUQUIBAMBILLA', value: '030601'}, 
{text: 'APURIMAC/GRAU/CURASCO', value: '030614'}, 
{text: 'APURIMAC/GRAU/CURPAHUASI', value: '030602'}, 
{text: 'APURIMAC/GRAU/HUAILLATI', value: '030603'}, 
{text: 'APURIMAC/GRAU/MAMARA', value: '030604'}, 
{text: 'APURIMAC/GRAU/MARISCAL GAMARRA', value: '030605'}, 
{text: 'APURIMAC/GRAU/MICAELA BASTIDAS', value: '030606'}, 
{text: 'APURIMAC/GRAU/PATAYPAMPA', value: '030608'}, 
{text: 'APURIMAC/GRAU/PROGRESO', value: '030607'}, 
{text: 'APURIMAC/GRAU/SAN ANTONIO', value: '030609'}, 
{text: 'APURIMAC/GRAU/SANTA ROSA', value: '030613'}, 
{text: 'APURIMAC/GRAU/TURPAY', value: '030610'}, 
{text: 'APURIMAC/GRAU/VILCABAMBA', value: '030611'}, 
{text: 'APURIMAC/GRAU/VIRUNDO', value: '030612'}, 
{text: 'AREQUIPA/AREQUIPA/ALTO SELVA ALEGRE', value: '040128'}, 
{text: 'AREQUIPA/AREQUIPA/AREQUIPA', value: '040101'}, 
{text: 'AREQUIPA/AREQUIPA/CAYMA', value: '040102'}, 
{text: 'AREQUIPA/AREQUIPA/CERRO COLORADO', value: '040103'}, 
{text: 'AREQUIPA/AREQUIPA/CHARACATO', value: '040104'}, 
{text: 'AREQUIPA/AREQUIPA/CHIGUATA', value: '040105'}, 
{text: 'AREQUIPA/AREQUIPA/JACOBO HUNTER', value: '040127'}, 
{text: 'AREQUIPA/AREQUIPA/JOSE LUIS BUSTAMANTE Y RIVERO', value: '040129'}, 
{text: 'AREQUIPA/AREQUIPA/LA JOYA', value: '040106'}, 
{text: 'AREQUIPA/AREQUIPA/MARIANO MELGAR', value: '040126'}, 
{text: 'AREQUIPA/AREQUIPA/MIRAFLORES', value: '040107'}, 
{text: 'AREQUIPA/AREQUIPA/MOLLEBAYA', value: '040108'}, 
{text: 'AREQUIPA/AREQUIPA/PAUCARPATA', value: '040109'}, 
{text: 'AREQUIPA/AREQUIPA/POCSI', value: '040110'}, 
{text: 'AREQUIPA/AREQUIPA/POLOBAYA', value: '040111'}, 
{text: 'AREQUIPA/AREQUIPA/QUEQUENA', value: '040112'}, 
{text: 'AREQUIPA/AREQUIPA/SABANDIA', value: '040113'}, 
{text: 'AREQUIPA/AREQUIPA/SACHACA', value: '040114'}, 
{text: 'AREQUIPA/AREQUIPA/SAN JUAN DE SIGUAS', value: '040115'}, 
{text: 'AREQUIPA/AREQUIPA/SAN JUAN DE TARUCANI', value: '040116'}, 
{text: 'AREQUIPA/AREQUIPA/SANTA ISABEL DE SIGUAS', value: '040117'}, 
{text: 'AREQUIPA/AREQUIPA/SOCABAYA', value: '040119'}, 
{text: 'AREQUIPA/AREQUIPA/STA RITA DE SIGUAS', value: '040118'}, 
{text: 'AREQUIPA/AREQUIPA/TIABAYA', value: '040120'}, 
{text: 'AREQUIPA/AREQUIPA/UCHUMAYO', value: '040121'}, 
{text: 'AREQUIPA/AREQUIPA/VITOR', value: '040122'}, 
{text: 'AREQUIPA/AREQUIPA/YANAHUARA', value: '040123'}, 
{text: 'AREQUIPA/AREQUIPA/YARABAMBA', value: '040124'}, 
{text: 'AREQUIPA/AREQUIPA/YURA', value: '040125'}, 
{text: 'AREQUIPA/CAMANA/ACHOMA', value: '040202'}, 
{text: 'AREQUIPA/CAMANA/CABANACONDE', value: '040203'}, 
{text: 'AREQUIPA/CAMANA/CALLALLI', value: '040205'}, 
{text: 'AREQUIPA/CAMANA/CAYLLOMA', value: '040204'}, 
{text: 'AREQUIPA/CAMANA/CHIVAY', value: '040201'}, 
{text: 'AREQUIPA/CAMANA/COPORAQUE', value: '040206'}, 
{text: 'AREQUIPA/CAMANA/HUAMBO', value: '040207'}, 
{text: 'AREQUIPA/CAMANA/HUANCA', value: '040208'}, 
{text: 'AREQUIPA/CAMANA/ICHUPAMPA', value: '040209'}, 
{text: 'AREQUIPA/CAMANA/LARI', value: '040210'}, 
{text: 'AREQUIPA/CAMANA/LLUTA', value: '040211'}, 
{text: 'AREQUIPA/CAMANA/MACA', value: '040212'}, 
{text: 'AREQUIPA/CAMANA/MADRIGAL', value: '040213'}, 
{text: 'AREQUIPA/CAMANA/MAJES', value: '040220'}, 
{text: 'AREQUIPA/CAMANA/SAN ANTONIO DE CHUCA', value: '040214'}, 
{text: 'AREQUIPA/CAMANA/SIBAYO', value: '040215'}, 
{text: 'AREQUIPA/CAMANA/TAPAY', value: '040216'}, 
{text: 'AREQUIPA/CAMANA/TISCO', value: '040217'}, 
{text: 'AREQUIPA/CAMANA/TUTI', value: '040218'}, 
{text: 'AREQUIPA/CAMANA/YANQUE', value: '040219'}, 
{text: 'AREQUIPA/CARAVELI/CAMANA', value: '040301'}, 
{text: 'AREQUIPA/CARAVELI/JOSE MARIA QUIMPER', value: '040302'}, 
{text: 'AREQUIPA/CARAVELI/MARIANO N VALCARCEL', value: '040303'}, 
{text: 'AREQUIPA/CARAVELI/MARISCAL CACERES', value: '040304'}, 
{text: 'AREQUIPA/CARAVELI/NICOLAS DE PIEROLA', value: '040305'}, 
{text: 'AREQUIPA/CARAVELI/OCONA', value: '040306'}, 
{text: 'AREQUIPA/CARAVELI/QUILCA', value: '040307'}, 
{text: 'AREQUIPA/CARAVELI/SAMUEL PASTOR', value: '040308'}, 
{text: 'AREQUIPA/CASTILLA/ACARI', value: '040402'}, 
{text: 'AREQUIPA/CASTILLA/ATICO', value: '040403'}, 
{text: 'AREQUIPA/CASTILLA/ATIQUIPA', value: '040404'}, 
{text: 'AREQUIPA/CASTILLA/BELLA UNION', value: '040405'}, 
{text: 'AREQUIPA/CASTILLA/CAHUACHO', value: '040406'}, 
{text: 'AREQUIPA/CASTILLA/CARAVELI', value: '040401'}, 
{text: 'AREQUIPA/CASTILLA/CHALA', value: '040407'}, 
{text: 'AREQUIPA/CASTILLA/CHAPARRA', value: '040408'}, 
{text: 'AREQUIPA/CASTILLA/HUANUHUANU', value: '040409'}, 
{text: 'AREQUIPA/CASTILLA/JAQUI', value: '040410'}, 
{text: 'AREQUIPA/CASTILLA/LOMAS', value: '040411'}, 
{text: 'AREQUIPA/CASTILLA/QUICACHA', value: '040412'}, 
{text: 'AREQUIPA/CASTILLA/YAUCA', value: '040413'}, 
{text: 'AREQUIPA/CAYLLOMA/ANDAGUA', value: '040502'}, 
{text: 'AREQUIPA/CAYLLOMA/APLAO', value: '040501'}, 
{text: 'AREQUIPA/CAYLLOMA/AYO', value: '040503'}, 
{text: 'AREQUIPA/CAYLLOMA/CHACHAS', value: '040504'}, 
{text: 'AREQUIPA/CAYLLOMA/CHILCAYMARCA', value: '040505'}, 
{text: 'AREQUIPA/CAYLLOMA/CHOCO', value: '040506'}, 
{text: 'AREQUIPA/CAYLLOMA/HUANCARQUI', value: '040507'}, 
{text: 'AREQUIPA/CAYLLOMA/MACHAGUAY', value: '040508'}, 
{text: 'AREQUIPA/CAYLLOMA/ORCOPAMPA', value: '040509'}, 
{text: 'AREQUIPA/CAYLLOMA/PAMPACOLCA', value: '040510'}, 
{text: 'AREQUIPA/CAYLLOMA/TIPAN', value: '040511'}, 
{text: 'AREQUIPA/CAYLLOMA/UNON', value: '040513'}, 
{text: 'AREQUIPA/CAYLLOMA/URACA', value: '040512'}, 
{text: 'AREQUIPA/CAYLLOMA/VIRACO', value: '040514'}, 
{text: 'AREQUIPA/CONDESUYOS/ANDARAY', value: '040602'}, 
{text: 'AREQUIPA/CONDESUYOS/CAYARANI', value: '040603'}, 
{text: 'AREQUIPA/CONDESUYOS/CHICHAS', value: '040604'}, 
{text: 'AREQUIPA/CONDESUYOS/CHUQUIBAMBA', value: '040601'}, 
{text: 'AREQUIPA/CONDESUYOS/IRAY', value: '040605'}, 
{text: 'AREQUIPA/CONDESUYOS/RIO GRANDE', value: '040608'}, 
{text: 'AREQUIPA/CONDESUYOS/SALAMANCA', value: '040606'}, 
{text: 'AREQUIPA/CONDESUYOS/YANAQUIHUA', value: '040607'}, 
{text: 'AREQUIPA/ISLAY/COCACHACRA', value: '040702'}, 
{text: 'AREQUIPA/ISLAY/DEAN VALDIVIA', value: '040703'}, 
{text: 'AREQUIPA/ISLAY/ISLAY', value: '040704'}, 
{text: 'AREQUIPA/ISLAY/MEJIA', value: '040705'}, 
{text: 'AREQUIPA/ISLAY/MOLLENDO', value: '040701'}, 
{text: 'AREQUIPA/ISLAY/PUNTA DE BOMBON', value: '040706'}, 
{text: 'AREQUIPA/LA UNION/ALCA', value: '040802'}, 
{text: 'AREQUIPA/LA UNION/CHARCANA', value: '040803'}, 
{text: 'AREQUIPA/LA UNION/COTAHUASI', value: '040801'}, 
{text: 'AREQUIPA/LA UNION/HUAYNACOTAS', value: '040804'}, 
{text: 'AREQUIPA/LA UNION/PAMPAMARCA', value: '040805'}, 
{text: 'AREQUIPA/LA UNION/PUYCA', value: '040806'}, 
{text: 'AREQUIPA/LA UNION/QUECHUALLA', value: '040807'}, 
{text: 'AREQUIPA/LA UNION/SAYLA', value: '040808'}, 
{text: 'AREQUIPA/LA UNION/TAURIA', value: '040809'}, 
{text: 'AREQUIPA/LA UNION/TOMEPAMPA', value: '040810'}, 
{text: 'AREQUIPA/LA UNION/TORO', value: '040811'}, 
{text: 'AYACUCHO/CANGALLO/CANGALLO', value: '050201'}, 
{text: 'AYACUCHO/CANGALLO/CHUSCHI', value: '050204'}, 
{text: 'AYACUCHO/CANGALLO/LOS MOROCHUCOS', value: '050206'}, 
{text: 'AYACUCHO/CANGALLO/MARIA PARADO DE BELLIDO', value: '050211'}, 
{text: 'AYACUCHO/CANGALLO/PARAS', value: '050207'}, 
{text: 'AYACUCHO/CANGALLO/TOTOS', value: '050208'}, 
{text: 'AYACUCHO/HUAMANGA/ACOCRO', value: '050111'}, 
{text: 'AYACUCHO/HUAMANGA/ACOS VINCHOS', value: '050102'}, 
{text: 'AYACUCHO/HUAMANGA/AYACUCHO', value: '050101'}, 
{text: 'AYACUCHO/HUAMANGA/CARMEN ALTO', value: '050103'}, 
{text: 'AYACUCHO/HUAMANGA/CHIARA', value: '050104'}, 
{text: 'AYACUCHO/HUAMANGA/JESUS NAZARENO', value: '050115'}, 
{text: 'AYACUCHO/HUAMANGA/OCROS', value: '050113'}, 
{text: 'AYACUCHO/HUAMANGA/PACAYCASA', value: '050114'}, 
{text: 'AYACUCHO/HUAMANGA/QUINUA', value: '050105'}, 
{text: 'AYACUCHO/HUAMANGA/SAN JOSE DE TICLLAS', value: '050106'}, 
{text: 'AYACUCHO/HUAMANGA/SAN JUAN BAUTISTA', value: '050107'}, 
{text: 'AYACUCHO/HUAMANGA/SANTIAGO DE PISCHA', value: '050108'}, 
{text: 'AYACUCHO/HUAMANGA/SOCOS', value: '050112'}, 
{text: 'AYACUCHO/HUAMANGA/TAMBILLO', value: '050110'}, 
{text: 'AYACUCHO/HUAMANGA/VINCHOS', value: '050109'}, 
{text: 'AYACUCHO/HUANCA SANCOS/AYAHUANCO', value: '050302'}, 
{text: 'AYACUCHO/HUANCA SANCOS/HUAMANGUILLA', value: '050303'}, 
{text: 'AYACUCHO/HUANCA SANCOS/HUANTA', value: '050301'}, 
{text: 'AYACUCHO/HUANCA SANCOS/IGUAIN', value: '050304'}, 
{text: 'AYACUCHO/HUANCA SANCOS/LLOCHEGUA', value: '050309'}, 
{text: 'AYACUCHO/HUANCA SANCOS/LURICOCHA', value: '050305'}, 
{text: 'AYACUCHO/HUANCA SANCOS/SANTILLANA', value: '050307'}, 
{text: 'AYACUCHO/HUANCA SANCOS/SIVIA', value: '050308'}, 
{text: 'AYACUCHO/HUANTA/ANCO', value: '050402'}, 
{text: 'AYACUCHO/HUANTA/AYNA', value: '050403'}, 
{text: 'AYACUCHO/HUANTA/CHILCAS', value: '050404'}, 
{text: 'AYACUCHO/HUANTA/CHUNGUI', value: '050405'}, 
{text: 'AYACUCHO/HUANTA/LUIS CARRANZA', value: '050407'}, 
{text: 'AYACUCHO/HUANTA/SAN MIGUEL', value: '050401'}, 
{text: 'AYACUCHO/HUANTA/SANTA ROSA', value: '050408'}, 
{text: 'AYACUCHO/HUANTA/TAMBO', value: '050406'}, 
{text: 'AYACUCHO/LA MAR/AUCARA', value: '050502'}, 
{text: 'AYACUCHO/LA MAR/CABANA', value: '050503'}, 
{text: 'AYACUCHO/LA MAR/CARMEN SALCEDO', value: '050504'}, 
{text: 'AYACUCHO/LA MAR/CHAVINA', value: '050506'}, 
{text: 'AYACUCHO/LA MAR/CHIPAO', value: '050508'}, 
{text: 'AYACUCHO/LA MAR/HUAC-HUAS', value: '050510'}, 
{text: 'AYACUCHO/LA MAR/LARAMATE', value: '050511'}, 
{text: 'AYACUCHO/LA MAR/LEONCIO PRADO', value: '050512'}, 
{text: 'AYACUCHO/LA MAR/LLAUTA', value: '050514'}, 
{text: 'AYACUCHO/LA MAR/LUCANAS', value: '050513'}, 
{text: 'AYACUCHO/LA MAR/OCANA', value: '050516'}, 
{text: 'AYACUCHO/LA MAR/OTOCA', value: '050517'}, 
{text: 'AYACUCHO/LA MAR/PUQUIO', value: '050501'}, 
{text: 'AYACUCHO/LA MAR/SAISA', value: '050529'}, 
{text: 'AYACUCHO/LA MAR/SAN CRISTOBAL', value: '050532'}, 
{text: 'AYACUCHO/LA MAR/SAN JUAN', value: '050521'}, 
{text: 'AYACUCHO/LA MAR/SAN PEDRO', value: '050522'}, 
{text: 'AYACUCHO/LA MAR/SAN PEDRO DE PALCO', value: '050531'}, 
{text: 'AYACUCHO/LA MAR/SANCOS', value: '050520'}, 
{text: 'AYACUCHO/LA MAR/SANTA LUCIA', value: '050525'}, 
{text: 'AYACUCHO/LA MAR/STA ANA DE HUAYCAHUACHO', value: '050524'}, 
{text: 'AYACUCHO/LUCANAS/CHUMPI', value: '050605'}, 
{text: 'AYACUCHO/LUCANAS/CORACORA', value: '050601'}, 
{text: 'AYACUCHO/LUCANAS/CORONEL CASTANEDA', value: '050604'}, 
{text: 'AYACUCHO/LUCANAS/PACAPAUSA', value: '050608'}, 
{text: 'AYACUCHO/LUCANAS/PULLO', value: '050611'}, 
{text: 'AYACUCHO/LUCANAS/PUYUSCA', value: '050612'}, 
{text: 'AYACUCHO/LUCANAS/SAN FCO DE RAVACAYCO', value: '050615'}, 
{text: 'AYACUCHO/LUCANAS/UPAHUACHO', value: '050616'}, 
{text: 'AYACUCHO/PARINACOCHAS/ALCAMENCA', value: '050702'}, 
{text: 'AYACUCHO/PARINACOCHAS/APONGO', value: '050703'}, 
{text: 'AYACUCHO/PARINACOCHAS/ASQUIPATA', value: '050715'}, 
{text: 'AYACUCHO/PARINACOCHAS/CANARIA', value: '050704'}, 
{text: 'AYACUCHO/PARINACOCHAS/CAYARA', value: '050706'}, 
{text: 'AYACUCHO/PARINACOCHAS/COLCA', value: '050707'}, 
{text: 'AYACUCHO/PARINACOCHAS/HUAMANQUIQUIA', value: '050709'}, 
{text: 'AYACUCHO/PARINACOCHAS/HUANCAPI', value: '050701'}, 
{text: 'AYACUCHO/PARINACOCHAS/HUANCARAYLLA', value: '050710'}, 
{text: 'AYACUCHO/PARINACOCHAS/HUAYA', value: '050708'}, 
{text: 'AYACUCHO/PARINACOCHAS/SARHUA', value: '050713'}, 
{text: 'AYACUCHO/PARINACOCHAS/VILCANCHOS', value: '050714'}, 
{text: 'AYACUCHO/PAUCAR DEL SARA SARA/CARAPO', value: '050804'}, 
{text: 'AYACUCHO/PAUCAR DEL SARA SARA/SACSAMARCA', value: '050802'}, 
{text: 'AYACUCHO/PAUCAR DEL SARA SARA/SANCOS', value: '050801'}, 
{text: 'AYACUCHO/PAUCAR DEL SARA SARA/SANTIAGO DE LUCANAMARCA', value: '050803'}, 
{text: 'AYACUCHO/SUCRE/ACCOMARCA', value: '050903'}, 
{text: 'AYACUCHO/SUCRE/CARHUANCA', value: '050904'}, 
{text: 'AYACUCHO/SUCRE/CONCEPCION', value: '050905'}, 
{text: 'AYACUCHO/SUCRE/HUAMBALPA', value: '050906'}, 
{text: 'AYACUCHO/SUCRE/INDEPENDENCIA', value: '050908'}, 
{text: 'AYACUCHO/SUCRE/SAURAMA', value: '050907'}, 
{text: 'AYACUCHO/SUCRE/VILCAS HUAMAN', value: '050901'}, 
{text: 'AYACUCHO/SUCRE/VISCHONGO', value: '050902'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/COLTA', value: '051002'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/CORCULLA', value: '051003'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/LAMPA', value: '051004'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/MARCABAMBA', value: '051005'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/OYOLO', value: '051006'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/PARARCA', value: '051007'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/PAUSA', value: '051001'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/SAN JAVIER DE ALPABAMBA', value: '051008'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/SAN JOSE DE USHUA', value: '051009'}, 
{text: 'AYACUCHO/VICTOR FAJARDO/SARA SARA', value: '051010'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/BELEN', value: '051102'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/CHALCOS', value: '051103'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/CHILCAYOC', value: '051110'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/HUACANA', value: '051109'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/MORCOLLA', value: '051111'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/PAICO', value: '051105'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/QUEROBAMBA', value: '051101'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/SAN PEDRO DE LARCAY', value: '051107'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/SAN SALVADOR DE QUIJE', value: '051104'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/SANTIAGO DE PAUCARAY', value: '051106'}, 
{text: 'AYACUCHO/VILCAS HUAMAN/SORAS', value: '051108'}, 
{text: 'CAJAMARCA/CAJABAMBA/CACHACHI', value: '060202'}, 
{text: 'CAJAMARCA/CAJABAMBA/CAJABAMBA', value: '060201'}, 
{text: 'CAJAMARCA/CAJABAMBA/CONDEBAMBA', value: '060203'}, 
{text: 'CAJAMARCA/CAJABAMBA/SITACOCHA', value: '060205'}, 
{text: 'CAJAMARCA/CAJAMARCA/ASUNCION', value: '060102'}, 
{text: 'CAJAMARCA/CAJAMARCA/CAJAMARCA', value: '060101'}, 
{text: 'CAJAMARCA/CAJAMARCA/CHETILLA', value: '060104'}, 
{text: 'CAJAMARCA/CAJAMARCA/COSPAN', value: '060103'}, 
{text: 'CAJAMARCA/CAJAMARCA/ENCANADA', value: '060105'}, 
{text: 'CAJAMARCA/CAJAMARCA/JESUS', value: '060106'}, 
{text: 'CAJAMARCA/CAJAMARCA/LLACANORA', value: '060108'}, 
{text: 'CAJAMARCA/CAJAMARCA/LOS BANOS DEL INCA', value: '060107'}, 
{text: 'CAJAMARCA/CAJAMARCA/MAGDALENA', value: '060109'}, 
{text: 'CAJAMARCA/CAJAMARCA/MATARA', value: '060110'}, 
{text: 'CAJAMARCA/CAJAMARCA/NAMORA', value: '060111'}, 
{text: 'CAJAMARCA/CAJAMARCA/SAN JUAN', value: '060112'}, 
{text: 'CAJAMARCA/CELENDIN/CELENDIN', value: '060301'}, 
{text: 'CAJAMARCA/CELENDIN/CHUMUCH', value: '060303'}, 
{text: 'CAJAMARCA/CELENDIN/CORTEGANA', value: '060302'}, 
{text: 'CAJAMARCA/CELENDIN/HUASMIN', value: '060304'}, 
{text: 'CAJAMARCA/CELENDIN/JORGE CHAVEZ', value: '060305'}, 
{text: 'CAJAMARCA/CELENDIN/JOSE GALVEZ', value: '060306'}, 
{text: 'CAJAMARCA/CELENDIN/LA LIBERTAD DE PALLAN', value: '060312'}, 
{text: 'CAJAMARCA/CELENDIN/MIGUEL IGLESIAS', value: '060307'}, 
{text: 'CAJAMARCA/CELENDIN/OXAMARCA', value: '060308'}, 
{text: 'CAJAMARCA/CELENDIN/SOROCHUCO', value: '060309'}, 
{text: 'CAJAMARCA/CELENDIN/SUCRE', value: '060310'}, 
{text: 'CAJAMARCA/CELENDIN/UTCO', value: '060311'}, 
{text: 'CAJAMARCA/CHOTA/CHILETE', value: '060403'}, 
{text: 'CAJAMARCA/CHOTA/CONTUMAZA', value: '060401'}, 
{text: 'CAJAMARCA/CHOTA/CUPISNIQUE', value: '060406'}, 
{text: 'CAJAMARCA/CHOTA/GUZMANGO', value: '060404'}, 
{text: 'CAJAMARCA/CHOTA/SAN BENITO', value: '060405'}, 
{text: 'CAJAMARCA/CHOTA/STA CRUZ DE TOLEDO', value: '060409'}, 
{text: 'CAJAMARCA/CHOTA/TANTARICA', value: '060407'}, 
{text: 'CAJAMARCA/CHOTA/YONAN', value: '060408'}, 
{text: 'CAJAMARCA/CONTUMAZA/CALLAYUC', value: '060502'}, 
{text: 'CAJAMARCA/CONTUMAZA/CHOROS', value: '060504'}, 
{text: 'CAJAMARCA/CONTUMAZA/CUJILLO', value: '060503'}, 
{text: 'CAJAMARCA/CONTUMAZA/CUTERVO', value: '060501'}, 
{text: 'CAJAMARCA/CONTUMAZA/LA RAMADA', value: '060505'}, 
{text: 'CAJAMARCA/CONTUMAZA/PIMPINGOS', value: '060506'}, 
{text: 'CAJAMARCA/CONTUMAZA/QUEROCOTILLO', value: '060507'}, 
{text: 'CAJAMARCA/CONTUMAZA/SAN ANDRES DE CUTERVO', value: '060508'}, 
{text: 'CAJAMARCA/CONTUMAZA/SAN JUAN DE CUTERVO', value: '060509'}, 
{text: 'CAJAMARCA/CONTUMAZA/SAN LUIS DE LUCMA', value: '060510'}, 
{text: 'CAJAMARCA/CONTUMAZA/SANTA CRUZ', value: '060511'}, 
{text: 'CAJAMARCA/CONTUMAZA/SANTO DOMINGO DE LA CAPILLA', value: '060512'}, 
{text: 'CAJAMARCA/CONTUMAZA/SANTO TOMAS', value: '060513'}, 
{text: 'CAJAMARCA/CONTUMAZA/SOCOTA', value: '060514'}, 
{text: 'CAJAMARCA/CONTUMAZA/TORIBIO CASANOVA', value: '060515'}, 
{text: 'CAJAMARCA/CUTERVO/ANGUIA', value: '060602'}, 
{text: 'CAJAMARCA/CUTERVO/CHADIN', value: '060605'}, 
{text: 'CAJAMARCA/CUTERVO/CHALAMARCA', value: '060619'}, 
{text: 'CAJAMARCA/CUTERVO/CHIGUIRIP', value: '060606'}, 
{text: 'CAJAMARCA/CUTERVO/CHIMBAN', value: '060607'}, 
{text: 'CAJAMARCA/CUTERVO/CHOROPAMPA', value: '060618'}, 
{text: 'CAJAMARCA/CUTERVO/CHOTA', value: '060601'}, 
{text: 'CAJAMARCA/CUTERVO/COCHABAMBA', value: '060603'}, 
{text: 'CAJAMARCA/CUTERVO/CONCHAN', value: '060604'}, 
{text: 'CAJAMARCA/CUTERVO/HUAMBOS', value: '060608'}, 
{text: 'CAJAMARCA/CUTERVO/LAJAS', value: '060609'}, 
{text: 'CAJAMARCA/CUTERVO/LLAMA', value: '060610'}, 
{text: 'CAJAMARCA/CUTERVO/MIRACOSTA', value: '060611'}, 
{text: 'CAJAMARCA/CUTERVO/PACCHA', value: '060612'}, 
{text: 'CAJAMARCA/CUTERVO/PION', value: '060613'}, 
{text: 'CAJAMARCA/CUTERVO/QUEROCOTO', value: '060614'}, 
{text: 'CAJAMARCA/CUTERVO/SAN JUAN DE LICUPIS', value: '060617'}, 
{text: 'CAJAMARCA/CUTERVO/TACABAMBA', value: '060615'}, 
{text: 'CAJAMARCA/CUTERVO/TOCMOCHE', value: '060616'}, 
{text: 'CAJAMARCA/HUALGAYOC/BAMBAMARCA', value: '060701'}, 
{text: 'CAJAMARCA/HUALGAYOC/CHUGUR', value: '060702'}, 
{text: 'CAJAMARCA/HUALGAYOC/HUALGAYOC', value: '060703'}, 
{text: 'CAJAMARCA/JAEN/BELLAVISTA', value: '060802'}, 
{text: 'CAJAMARCA/JAEN/CHONTALI', value: '060804'}, 
{text: 'CAJAMARCA/JAEN/COLASAY', value: '060803'}, 
{text: 'CAJAMARCA/JAEN/HUABAL', value: '060812'}, 
{text: 'CAJAMARCA/JAEN/JAEN', value: '060801'}, 
{text: 'CAJAMARCA/JAEN/LAS PIRIAS', value: '060811'}, 
{text: 'CAJAMARCA/JAEN/POMAHUACA', value: '060805'}, 
{text: 'CAJAMARCA/JAEN/PUCARA', value: '060806'}, 
{text: 'CAJAMARCA/JAEN/SALLIQUE', value: '060807'}, 
{text: 'CAJAMARCA/JAEN/SAN FELIPE', value: '060808'}, 
{text: 'CAJAMARCA/JAEN/SAN JOSE DEL ALTO', value: '060809'}, 
{text: 'CAJAMARCA/JAEN/SANTA ROSA', value: '060810'}, 
{text: 'CAJAMARCA/SAN IGNACIO/', value: 'NULL'}, 
{text: 'CAJAMARCA/SAN IGNACIO/ANDABAMBA', value: '060910'}, 
{text: 'CAJAMARCA/SAN IGNACIO/CATACHE', value: '060902'}, 
{text: 'CAJAMARCA/SAN IGNACIO/CHANCAIBANOS', value: '060903'}, 
{text: 'CAJAMARCA/SAN IGNACIO/LA ESPERANZA', value: '060904'}, 
{text: 'CAJAMARCA/SAN IGNACIO/NINABAMBA', value: '060905'}, 
{text: 'CAJAMARCA/SAN IGNACIO/PULAN', value: '060906'}, 
{text: 'CAJAMARCA/SAN IGNACIO/SANTA CRUZ', value: '060901'}, 
{text: 'CAJAMARCA/SAN IGNACIO/SAUCEPAMPA', value: '060911'}, 
{text: 'CAJAMARCA/SAN IGNACIO/SEXI', value: '060907'}, 
{text: 'CAJAMARCA/SAN IGNACIO/UTICYACU', value: '060908'}, 
{text: 'CAJAMARCA/SAN IGNACIO/YAUYUCAN', value: '060909'}, 
{text: 'CAJAMARCA/SAN MARCOS/BOLIVAR', value: '061013'}, 
{text: 'CAJAMARCA/SAN MARCOS/CALQUIS', value: '061002'}, 
{text: 'CAJAMARCA/SAN MARCOS/CATILLUC', value: '061012'}, 
{text: 'CAJAMARCA/SAN MARCOS/EL PRADO', value: '061009'}, 
{text: 'CAJAMARCA/SAN MARCOS/LA FLORIDA', value: '061003'}, 
{text: 'CAJAMARCA/SAN MARCOS/LLAPA', value: '061004'}, 
{text: 'CAJAMARCA/SAN MARCOS/NANCHOC', value: '061005'}, 
{text: 'CAJAMARCA/SAN MARCOS/NIEPOS', value: '061006'}, 
{text: 'CAJAMARCA/SAN MARCOS/SAN GREGORIO', value: '061007'}, 
{text: 'CAJAMARCA/SAN MARCOS/SAN MIGUEL', value: '061001'}, 
{text: 'CAJAMARCA/SAN MARCOS/SAN SILVESTRE DE COCHAN', value: '061008'}, 
{text: 'CAJAMARCA/SAN MARCOS/TONGOD', value: '061011'}, 
{text: 'CAJAMARCA/SAN MARCOS/UNION AGUA BLANCA', value: '061010'}, 
{text: 'CAJAMARCA/SAN MIGUEL/CHIRINOS', value: '061102'}, 
{text: 'CAJAMARCA/SAN MIGUEL/HUARANGO', value: '061103'}, 
{text: 'CAJAMARCA/SAN MIGUEL/LA COIPA', value: '061105'}, 
{text: 'CAJAMARCA/SAN MIGUEL/NAMBALLE', value: '061104'}, 
{text: 'CAJAMARCA/SAN MIGUEL/SAN IGNACIO', value: '061101'}, 
{text: 'CAJAMARCA/SAN MIGUEL/SAN JOSE DE LOURDES', value: '061106'}, 
{text: 'CAJAMARCA/SAN MIGUEL/TABACONAS', value: '061107'}, 
{text: 'CAJAMARCA/SAN PABLO/CHANCAY', value: '061207'}, 
{text: 'CAJAMARCA/SAN PABLO/EDUARDO VILLANUEVA', value: '061205'}, 
{text: 'CAJAMARCA/SAN PABLO/GREGORIO PITA', value: '061203'}, 
{text: 'CAJAMARCA/SAN PABLO/ICHOCAN', value: '061202'}, 
{text: 'CAJAMARCA/SAN PABLO/JOSE MANUEL QUIROZ', value: '061204'}, 
{text: 'CAJAMARCA/SAN PABLO/JOSE SABOGAL', value: '061206'}, 
{text: 'CAJAMARCA/SAN PABLO/PEDRO GALVEZ', value: '061201'}, 
{text: 'CAJAMARCA/SANTA CRUZ/SAN BERNARDINO', value: '061302'}, 
{text: 'CAJAMARCA/SANTA CRUZ/SAN LUIS', value: '061303'}, 
{text: 'CAJAMARCA/SANTA CRUZ/SAN PABLO', value: '061301'}, 
{text: 'CAJAMARCA/SANTA CRUZ/TUMBADEN', value: '061304'}, 
{text: 'CUSCO/ACOMAYO/ACOMAYO', value: '080201'}, 
{text: 'CUSCO/ACOMAYO/ACOPIA', value: '080202'}, 
{text: 'CUSCO/ACOMAYO/ACOS', value: '080203'}, 
{text: 'CUSCO/ACOMAYO/MOSOC LLACTA', value: '080207'}, 
{text: 'CUSCO/ACOMAYO/POMACANCHI', value: '080204'}, 
{text: 'CUSCO/ACOMAYO/RONDOCAN', value: '080205'}, 
{text: 'CUSCO/ACOMAYO/SANGARARA', value: '080206'}, 
{text: 'CUSCO/ANTA/ANCAHUASI', value: '080309'}, 
{text: 'CUSCO/ANTA/ANTA', value: '080301'}, 
{text: 'CUSCO/ANTA/CACHIMAYO', value: '080308'}, 
{text: 'CUSCO/ANTA/CHINCHAYPUJIO', value: '080302'}, 
{text: 'CUSCO/ANTA/HUAROCONDO', value: '080303'}, 
{text: 'CUSCO/ANTA/LIMATAMBO', value: '080304'}, 
{text: 'CUSCO/ANTA/MOLLEPATA', value: '080305'}, 
{text: 'CUSCO/ANTA/PUCYURA', value: '080306'}, 
{text: 'CUSCO/ANTA/ZURITE', value: '080307'}, 
{text: 'CUSCO/CALCA/CALCA', value: '080401'}, 
{text: 'CUSCO/CALCA/COYA', value: '080402'}, 
{text: 'CUSCO/CALCA/LAMAY', value: '080403'}, 
{text: 'CUSCO/CALCA/LARES', value: '080404'}, 
{text: 'CUSCO/CALCA/PISAC', value: '080405'}, 
{text: 'CUSCO/CALCA/SAN SALVADOR', value: '080406'}, 
{text: 'CUSCO/CALCA/TARAY', value: '080407'}, 
{text: 'CUSCO/CALCA/YANATILE', value: '080408'}, 
{text: 'CUSCO/CANAS/CHECCA', value: '080502'}, 
{text: 'CUSCO/CANAS/KUNTURKANKI', value: '080503'}, 
{text: 'CUSCO/CANAS/LANGUI', value: '080504'}, 
{text: 'CUSCO/CANAS/LAYO', value: '080505'}, 
{text: 'CUSCO/CANAS/PAMPAMARCA', value: '080506'}, 
{text: 'CUSCO/CANAS/QUEHUE', value: '080507'}, 
{text: 'CUSCO/CANAS/TUPAC AMARU', value: '080508'}, 
{text: 'CUSCO/CANAS/YANAOCA', value: '080501'}, 
{text: 'CUSCO/CANCHIS/CHECACUPE', value: '080603'}, 
{text: 'CUSCO/CANCHIS/COMBAPATA', value: '080602'}, 
{text: 'CUSCO/CANCHIS/MARANGANI', value: '080604'}, 
{text: 'CUSCO/CANCHIS/PITUMARCA', value: '080605'}, 
{text: 'CUSCO/CANCHIS/SAN PABLO', value: '080606'}, 
{text: 'CUSCO/CANCHIS/SAN PEDRO', value: '080607'}, 
{text: 'CUSCO/CANCHIS/SICUANI', value: '080601'}, 
{text: 'CUSCO/CANCHIS/TINTA', value: '080608'}, 
{text: 'CUSCO/CHUMBIVILCAS/CAPACMARCA', value: '080702'}, 
{text: 'CUSCO/CHUMBIVILCAS/CHAMACA', value: '080704'}, 
{text: 'CUSCO/CHUMBIVILCAS/COLQUEMARCA', value: '080703'}, 
{text: 'CUSCO/CHUMBIVILCAS/LIVITACA', value: '080705'}, 
{text: 'CUSCO/CHUMBIVILCAS/LLUSCO', value: '080706'}, 
{text: 'CUSCO/CHUMBIVILCAS/QUINOTA', value: '080707'}, 
{text: 'CUSCO/CHUMBIVILCAS/SANTO TOMAS', value: '080701'}, 
{text: 'CUSCO/CHUMBIVILCAS/VELILLE', value: '080708'}, 
{text: 'CUSCO/CUSCO/CCORCA', value: '080102'}, 
{text: 'CUSCO/CUSCO/CUSCO', value: '080101'}, 
{text: 'CUSCO/CUSCO/POROY', value: '080103'}, 
{text: 'CUSCO/CUSCO/SAN JERONIMO', value: '080104'}, 
{text: 'CUSCO/CUSCO/SAN SEBASTIAN', value: '080105'}, 
{text: 'CUSCO/CUSCO/SANTIAGO', value: '080106'}, 
{text: 'CUSCO/CUSCO/SAYLLA', value: '080107'}, 
{text: 'CUSCO/CUSCO/WANCHAQ', value: '080108'}, 
{text: 'CUSCO/ESPINAR/ALTO PICHIGUA', value: '080808'}, 
{text: 'CUSCO/ESPINAR/CONDOROMA', value: '080802'}, 
{text: 'CUSCO/ESPINAR/COPORAQUE', value: '080803'}, 
{text: 'CUSCO/ESPINAR/ESPINAR', value: '080801'}, 
{text: 'CUSCO/ESPINAR/OCORURO', value: '080804'}, 
{text: 'CUSCO/ESPINAR/PALLPATA', value: '080805'}, 
{text: 'CUSCO/ESPINAR/PICHIGUA', value: '080806'}, 
{text: 'CUSCO/ESPINAR/SUYKUTAMBO', value: '080807'}, 
{text: 'CUSCO/LA CONVENCION/', value: 'NULL'}, 
{text: 'CUSCO/LA CONVENCION/ECHARATE', value: '080902'}, 
{text: 'CUSCO/LA CONVENCION/HUAYOPATA', value: '080903'}, 
{text: 'CUSCO/LA CONVENCION/KIMBIRI', value: '080909'}, 
{text: 'CUSCO/LA CONVENCION/MARANURA', value: '080904'}, 
{text: 'CUSCO/LA CONVENCION/OCOBAMBA', value: '080905'}, 
{text: 'CUSCO/LA CONVENCION/PICHARI', value: '080910'}, 
{text: 'CUSCO/LA CONVENCION/QUELLOUNO', value: '080908'}, 
{text: 'CUSCO/LA CONVENCION/SANTA ANA', value: '080901'}, 
{text: 'CUSCO/LA CONVENCION/SANTA TERESA', value: '080906'}, 
{text: 'CUSCO/LA CONVENCION/VILCABAMBA', value: '080907'}, 
{text: 'CUSCO/PARURO/ACCHA', value: '081002'}, 
{text: 'CUSCO/PARURO/CCAPI', value: '081003'}, 
{text: 'CUSCO/PARURO/COLCHA', value: '081004'}, 
{text: 'CUSCO/PARURO/HUANOQUITE', value: '081005'}, 
{text: 'CUSCO/PARURO/OMACHA', value: '081006'}, 
{text: 'CUSCO/PARURO/PACCARITAMBO', value: '081008'}, 
{text: 'CUSCO/PARURO/PARURO', value: '081001'}, 
{text: 'CUSCO/PARURO/PILLPINTO', value: '081009'}, 
{text: 'CUSCO/PARURO/YAURISQUE', value: '081007'}, 
{text: 'CUSCO/PAUCARTAMBO/CAICAY', value: '081102'}, 
{text: 'CUSCO/PAUCARTAMBO/CHALLABAMBA', value: '081104'}, 
{text: 'CUSCO/PAUCARTAMBO/COLQUEPATA', value: '081103'}, 
{text: 'CUSCO/PAUCARTAMBO/COSNIPATA', value: '081105'}, 
{text: 'CUSCO/PAUCARTAMBO/HUANCARANI', value: '081106'}, 
{text: 'CUSCO/PAUCARTAMBO/PAUCARTAMBO', value: '081101'}, 
{text: 'CUSCO/QUISPICANCHIS/ANDAHUAYLILLAS', value: '081202'}, 
{text: 'CUSCO/QUISPICANCHIS/CAMANTI', value: '081203'}, 
{text: 'CUSCO/QUISPICANCHIS/CCARHUAYO', value: '081204'}, 
{text: 'CUSCO/QUISPICANCHIS/CCATCA', value: '081205'}, 
{text: 'CUSCO/QUISPICANCHIS/CUSIPATA', value: '081206'}, 
{text: 'CUSCO/QUISPICANCHIS/HUARO', value: '081207'}, 
{text: 'CUSCO/QUISPICANCHIS/LUCRE', value: '081208'}, 
{text: 'CUSCO/QUISPICANCHIS/MARCAPATA', value: '081209'}, 
{text: 'CUSCO/QUISPICANCHIS/OCONGATE', value: '081210'}, 
{text: 'CUSCO/QUISPICANCHIS/OROPESA', value: '081211'}, 
{text: 'CUSCO/QUISPICANCHIS/QUIQUIJANA', value: '081212'}, 
{text: 'CUSCO/QUISPICANCHIS/SAN JUAN BAUTISTA', value: 'NULL'}, 
{text: 'CUSCO/QUISPICANCHIS/URCOS', value: '081201'}, 
{text: 'CUSCO/URUBAMBA/CHINCHERO', value: '081302'}, 
{text: 'CUSCO/URUBAMBA/HUAYLLABAMBA', value: '081303'}, 
{text: 'CUSCO/URUBAMBA/MACHUPICCHU', value: '081304'}, 
{text: 'CUSCO/URUBAMBA/MARAS', value: '081305'}, 
{text: 'CUSCO/URUBAMBA/OLLANTAYTAMBO', value: '081306'}, 
{text: 'CUSCO/URUBAMBA/URUBAMBA', value: '081301'}, 
{text: 'CUSCO/URUBAMBA/YUCAY', value: '081307'}, 
{text: 'HUANCAVELICA/ACOBAMBA/ACOBAMBA', value: '090201'}, 
{text: 'HUANCAVELICA/ACOBAMBA/ANDABAMBA', value: '090203'}, 
{text: 'HUANCAVELICA/ACOBAMBA/ANTA', value: '090202'}, 
{text: 'HUANCAVELICA/ACOBAMBA/CAJA', value: '090204'}, 
{text: 'HUANCAVELICA/ACOBAMBA/MARCAS', value: '090205'}, 
{text: 'HUANCAVELICA/ACOBAMBA/PAUCARA', value: '090206'}, 
{text: 'HUANCAVELICA/ACOBAMBA/POMACOCHA', value: '090207'}, 
{text: 'HUANCAVELICA/ACOBAMBA/ROSARIO', value: '090208'}, 
{text: 'HUANCAVELICA/ANGARAES/ANCHONGA', value: '090302'}, 
{text: 'HUANCAVELICA/ANGARAES/CALLANMARCA', value: '090303'}, 
{text: 'HUANCAVELICA/ANGARAES/CCOCHACCASA', value: '090312'}, 
{text: 'HUANCAVELICA/ANGARAES/CHINCHO', value: '090305'}, 
{text: 'HUANCAVELICA/ANGARAES/CONGALLA', value: '090304'}, 
{text: 'HUANCAVELICA/ANGARAES/HUANCA HUANCA', value: '090307'}, 
{text: 'HUANCAVELICA/ANGARAES/HUAYLLAY GRANDE', value: '090306'}, 
{text: 'HUANCAVELICA/ANGARAES/JULCAMARCA', value: '090308'}, 
{text: 'HUANCAVELICA/ANGARAES/LIRCAY', value: '090301'}, 
{text: 'HUANCAVELICA/ANGARAES/SAN ANTONIO DE ANTAPARCO', value: '090309'}, 
{text: 'HUANCAVELICA/ANGARAES/SECCLLA', value: '090311'}, 
{text: 'HUANCAVELICA/ANGARAES/STO TOMAS DE PATA', value: '090310'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/ARMA', value: '090402'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/AURAHUA', value: '090403'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/CAPILLAS', value: '090405'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/CASTROVIRREYNA', value: '090401'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/CHUPAMARCA', value: '090408'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/COCAS', value: '090406'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/HUACHOS', value: '090409'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/HUAMATAMBO', value: '090410'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/MOLLEPAMPA', value: '090414'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/SAN JUAN', value: '090422'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/SANTA ANA', value: '090429'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/TANTARA', value: '090427'}, 
{text: 'HUANCAVELICA/CASTROVIRREYNA/TICRAPO', value: '090428'}, 
{text: 'HUANCAVELICA/CHURCAMPA/ACOSTAMBO', value: '090502'}, 
{text: 'HUANCAVELICA/CHURCAMPA/ACRAQUIA', value: '090503'}, 
{text: 'HUANCAVELICA/CHURCAMPA/AHUAYCHA', value: '090504'}, 
{text: 'HUANCAVELICA/CHURCAMPA/COLCABAMBA', value: '090506'}, 
{text: 'HUANCAVELICA/CHURCAMPA/DANIEL HERNANDEZ', value: '090509'}, 
{text: 'HUANCAVELICA/CHURCAMPA/HUACHOCOLPA', value: '090511'}, 
{text: 'HUANCAVELICA/CHURCAMPA/HUARIBAMBA', value: '090512'}, 
{text: 'HUANCAVELICA/CHURCAMPA/NAHUIMPUQUIO', value: '090515'}, 
{text: 'HUANCAVELICA/CHURCAMPA/PAMPAS', value: '090501'}, 
{text: 'HUANCAVELICA/CHURCAMPA/PAZOS', value: '090517'}, 
{text: 'HUANCAVELICA/CHURCAMPA/QUISHUAR', value: '090518'}, 
{text: 'HUANCAVELICA/CHURCAMPA/SALCABAMBA', value: '090519'}, 
{text: 'HUANCAVELICA/CHURCAMPA/SALCAHUASI', value: '090526'}, 
{text: 'HUANCAVELICA/CHURCAMPA/SAN MARCOS DE ROCCHAC', value: '090520'}, 
{text: 'HUANCAVELICA/CHURCAMPA/SURCUBAMBA', value: '090523'}, 
{text: 'HUANCAVELICA/CHURCAMPA/TINTAY PUNCU', value: '090525'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/ACOBAMBILLA', value: '090102'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/ACORIA', value: '090103'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/ASCENCION', value: '090119'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/CONAYCA', value: '090104'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/CUENCA', value: '090105'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/HUACHOCOLPA', value: '090106'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/HUANCAVELICA', value: '090101'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/HUANDO', value: '090120'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/HUAYLLAHUARA', value: '090108'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/IZCUCHACA', value: '090109'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/LARIA', value: '090110'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/MANTA', value: '090111'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/MARISCAL CACERES', value: '090112'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/MOYA', value: '090113'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/NUEVO OCCORO', value: '090114'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/PALCA', value: '090115'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/PILCHACA', value: '090116'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/VILCA', value: '090117'}, 
{text: 'HUANCAVELICA/HUANCAVELICA/YAULI', value: '090118'}, 
{text: 'HUANCAVELICA/HUAYTARA/AYAVI', value: '090601'}, 
{text: 'HUANCAVELICA/HUAYTARA/CORDOVA', value: '090602'}, 
{text: 'HUANCAVELICA/HUAYTARA/HUAYACUNDO ARMA', value: '090603'}, 
{text: 'HUANCAVELICA/HUAYTARA/HUAYTARA', value: '090604'}, 
{text: 'HUANCAVELICA/HUAYTARA/LARAMARCA', value: '090605'}, 
{text: 'HUANCAVELICA/HUAYTARA/OCOYO', value: '090606'}, 
{text: 'HUANCAVELICA/HUAYTARA/PILPICHACA', value: '090607'}, 
{text: 'HUANCAVELICA/HUAYTARA/QUERCO', value: '090608'}, 
{text: 'HUANCAVELICA/HUAYTARA/QUITO ARMA', value: '090609'}, 
{text: 'HUANCAVELICA/HUAYTARA/SAN ANTONIO DE CUSICANCHA', value: '090610'}, 
{text: 'HUANCAVELICA/HUAYTARA/SAN FRANCISCO DE SANGAYAICO', value: '090611'}, 
{text: 'HUANCAVELICA/HUAYTARA/SAN ISIDRO', value: '090612'}, 
{text: 'HUANCAVELICA/HUAYTARA/SANTIAGO DE CHOCORVOS', value: '090613'}, 
{text: 'HUANCAVELICA/HUAYTARA/SANTIAGO DE QUIRAHUARA', value: '090614'}, 
{text: 'HUANCAVELICA/HUAYTARA/SANTO DOMINGO DE CAPILLA', value: '090615'}, 
{text: 'HUANCAVELICA/HUAYTARA/TAMBO', value: '090616'}, 
{text: 'HUANCAVELICA/TAYACAJA/ANCO', value: '090702'}, 
{text: 'HUANCAVELICA/TAYACAJA/CHINCHIHUASI', value: '090703'}, 
{text: 'HUANCAVELICA/TAYACAJA/CHURCAMPA', value: '090701'}, 
{text: 'HUANCAVELICA/TAYACAJA/EL CARMEN', value: '090704'}, 
{text: 'HUANCAVELICA/TAYACAJA/LA MERCED', value: '090705'}, 
{text: 'HUANCAVELICA/TAYACAJA/LOCROJA', value: '090706'}, 
{text: 'HUANCAVELICA/TAYACAJA/PACHAMARCA', value: '090710'}, 
{text: 'HUANCAVELICA/TAYACAJA/PAUCARBAMBA', value: '090707'}, 
{text: 'HUANCAVELICA/TAYACAJA/SAN MIGUEL DE MAYOC', value: '090708'}, 
{text: 'HUANCAVELICA/TAYACAJA/SAN PEDRO DE CORIS', value: '090709'}, 
{text: 'HUANUCO/AMBO/AMBO', value: '100201'}, 
{text: 'HUANUCO/AMBO/CAYNA', value: '100202'}, 
{text: 'HUANUCO/AMBO/COLPAS', value: '100203'}, 
{text: 'HUANUCO/AMBO/CONCHAMARCA', value: '100204'}, 
{text: 'HUANUCO/AMBO/HUACAR', value: '100205'}, 
{text: 'HUANUCO/AMBO/SAN FRANCISCO', value: '100206'}, 
{text: 'HUANUCO/AMBO/SAN RAFAEL', value: '100207'}, 
{text: 'HUANUCO/AMBO/TOMAY KICHWA', value: '100208'}, 
{text: 'HUANUCO/DOS DE MAYO/CHUQUIS', value: '100307'}, 
{text: 'HUANUCO/DOS DE MAYO/LA UNION', value: '100301'}, 
{text: 'HUANUCO/DOS DE MAYO/MARIAS', value: '100312'}, 
{text: 'HUANUCO/DOS DE MAYO/PACHAS', value: '100314'}, 
{text: 'HUANUCO/DOS DE MAYO/QUIVILLA', value: '100316'}, 
{text: 'HUANUCO/DOS DE MAYO/RIPAN', value: '100317'}, 
{text: 'HUANUCO/DOS DE MAYO/SHUNQUI', value: '100321'}, 
{text: 'HUANUCO/DOS DE MAYO/SILLAPATA', value: '100322'}, 
{text: 'HUANUCO/DOS DE MAYO/YANAS', value: '100323'}, 
{text: 'HUANUCO/HUACAYBAMBA/ARANCAY', value: '100402'}, 
{text: 'HUANUCO/HUACAYBAMBA/CHAVIN DE PARIARCA', value: '100403'}, 
{text: 'HUANUCO/HUACAYBAMBA/JACAS GRANDE', value: '100404'}, 
{text: 'HUANUCO/HUACAYBAMBA/JIRCAN', value: '100405'}, 
{text: 'HUANUCO/HUACAYBAMBA/LLATA', value: '100401'}, 
{text: 'HUANUCO/HUACAYBAMBA/MIRAFLORES', value: '100406'}, 
{text: 'HUANUCO/HUACAYBAMBA/MONZON ', value: '100407'}, 
{text: 'HUANUCO/HUACAYBAMBA/PUNCHAO', value: '100408'}, 
{text: 'HUANUCO/HUACAYBAMBA/PUNOS', value: '100409'}, 
{text: 'HUANUCO/HUACAYBAMBA/SINGA', value: '100410'}, 
{text: 'HUANUCO/HUACAYBAMBA/TANTAMAYO', value: '100411'}, 
{text: 'HUANUCO/HUAMALIES/CHOLON', value: '100502'}, 
{text: 'HUANUCO/HUAMALIES/HUACRACHUCO', value: '100501'}, 
{text: 'HUANUCO/HUAMALIES/SAN BUENAVENTURA', value: '100505'}, 
{text: 'HUANUCO/HUANUCO/AMARILIS', value: '100110'}, 
{text: 'HUANUCO/HUANUCO/CHINCHAO', value: '100102'}, 
{text: 'HUANUCO/HUANUCO/CHURUBAMBA', value: '100103'}, 
{text: 'HUANUCO/HUANUCO/HUANUCO', value: '100101'}, 
{text: 'HUANUCO/HUANUCO/MARGOS', value: '100104'}, 
{text: 'HUANUCO/HUANUCO/PILLCO MARCA', value: '100111'}, 
{text: 'HUANUCO/HUANUCO/QUISQUI', value: '100105'}, 
{text: 'HUANUCO/HUANUCO/SAN FCO DE CAYRAN', value: '100106'}, 
{text: 'HUANUCO/HUANUCO/SAN PEDRO DE CHAULAN', value: '100107'}, 
{text: 'HUANUCO/HUANUCO/STA MARIA DEL VALLE', value: '100108'}, 
{text: 'HUANUCO/HUANUCO/YARUMAYO', value: '100109'}, 
{text: 'HUANUCO/LAURICOCHA/BANOS', value: '101002'}, 
{text: 'HUANUCO/LAURICOCHA/JESUS', value: '101001'}, 
{text: 'HUANUCO/LAURICOCHA/JIVIA', value: '101007'}, 
{text: 'HUANUCO/LAURICOCHA/QUEROPALCA', value: '101004'}, 
{text: 'HUANUCO/LAURICOCHA/RONDOS', value: '101006'}, 
{text: 'HUANUCO/LAURICOCHA/SAN FRANCISCO DE ASIS', value: '101003'}, 
{text: 'HUANUCO/LAURICOCHA/SAN MIGUEL DE CAURI', value: '101005'}, 
{text: 'HUANUCO/LEONCIO PRADO/CHUQUIBAMBILLA', value: 'NULL'}, 
{text: 'HUANUCO/LEONCIO PRADO/DANIEL ALOMIA ROBLES', value: '100602'}, 
{text: 'HUANUCO/LEONCIO PRADO/HERMILIO VALDIZAN', value: '100603'}, 
{text: 'HUANUCO/LEONCIO PRADO/JOSE CRESPO Y CASTILLO', value: '100606'}, 
{text: 'HUANUCO/LEONCIO PRADO/LUYANDO', value: '100604'}, 
{text: 'HUANUCO/LEONCIO PRADO/MARIANO DAMASO BERAUN', value: '100605'}, 
{text: 'HUANUCO/LEONCIO PRADO/RUPA RUPA', value: '100601'}, 
{text: 'HUANUCO/MARAÐON/CHAGLLA', value: '100702'}, 
{text: 'HUANUCO/MARAÐON/MOLINO', value: '100704'}, 
{text: 'HUANUCO/MARAÐON/PANAO', value: '100701'}, 
{text: 'HUANUCO/MARAÐON/UMARI', value: '100706'}, 
{text: 'HUANUCO/PACHITEA/CODO DEL POZUZO', value: '100803'}, 
{text: 'HUANUCO/PACHITEA/HONORIA', value: '100801'}, 
{text: 'HUANUCO/PACHITEA/PUERTO INCA', value: '100802'}, 
{text: 'HUANUCO/PACHITEA/TOURNAVISTA', value: '100804'}, 
{text: 'HUANUCO/PACHITEA/YUYAPICHIS', value: '100805'}, 
{text: 'HUANUCO/PUERTO INCA/CANCHABAMBA', value: '100903'}, 
{text: 'HUANUCO/PUERTO INCA/COCHABAMBA', value: '100904'}, 
{text: 'HUANUCO/PUERTO INCA/HUACAYBAMBA', value: '100901'}, 
{text: 'HUANUCO/PUERTO INCA/PINRA', value: '100902'}, 
{text: 'HUANUCO/YAROWILCA/APARICIO POMARES (CHUPAN)', value: '101102'}, 
{text: 'HUANUCO/YAROWILCA/CAHUAC', value: '101103'}, 
{text: 'HUANUCO/YAROWILCA/CHACABAMBA', value: '101104'}, 
{text: 'HUANUCO/YAROWILCA/CHAVINILLO', value: '101101'}, 
{text: 'HUANUCO/YAROWILCA/CHORAS                   ', value: '101108'}, 
{text: 'HUANUCO/YAROWILCA/JACAS CHICO', value: '101105'}, 
{text: 'HUANUCO/YAROWILCA/OBAS', value: '101106'}, 
{text: 'HUANUCO/YAROWILCA/PAMPAMARCA', value: '101107'}, 
{text: 'ICA/CHINCHA/ALTO LARAN', value: '110209'}, 
{text: 'ICA/CHINCHA/CHAVIN', value: '110202'}, 
{text: 'ICA/CHINCHA/CHINCHA ALTA', value: '110201'}, 
{text: 'ICA/CHINCHA/CHINCHA BAJA', value: '110203'}, 
{text: 'ICA/CHINCHA/EL CARMEN', value: '110204'}, 
{text: 'ICA/CHINCHA/GROCIO PRADO', value: '110205'}, 
{text: 'ICA/CHINCHA/PUEBLO NUEVO', value: '110210'}, 
{text: 'ICA/CHINCHA/SAN JUAN DE YANAC', value: '110211'}, 
{text: 'ICA/CHINCHA/SAN PEDRO DE HUACARPANA', value: '110206'}, 
{text: 'ICA/CHINCHA/SUNAMPE', value: '110207'}, 
{text: 'ICA/CHINCHA/TAMBO DE MORA', value: '110208'}, 
{text: 'ICA/ICA/ICA', value: '110101'}, 
{text: 'ICA/ICA/LA TINGUINA', value: '110102'}, 
{text: 'ICA/ICA/LOS AQUIJES', value: '110103'}, 
{text: 'ICA/ICA/OCUCAJE', value: '110114'}, 
{text: 'ICA/ICA/PACHACUTEC', value: '110113'}, 
{text: 'ICA/ICA/PARCONA', value: '110104'}, 
{text: 'ICA/ICA/PUEBLO NUEVO', value: '110105'}, 
{text: 'ICA/ICA/SALAS', value: '110106'}, 
{text: 'ICA/ICA/SAN JOSE DE LOS MOLINOS', value: '110107'}, 
{text: 'ICA/ICA/SAN JUAN BAUTISTA', value: '110108'}, 
{text: 'ICA/ICA/SANTIAGO', value: '110109'}, 
{text: 'ICA/ICA/SUBTANJALLA', value: '110110'}, 
{text: 'ICA/ICA/TATE', value: '110112'}, 
{text: 'ICA/ICA/YAUCA DEL ROSARIO', value: '110111'}, 
{text: 'ICA/NAZCA/CHANGUILLO', value: '110302'}, 
{text: 'ICA/NAZCA/EL INGENIO', value: '110303'}, 
{text: 'ICA/NAZCA/MARCONA', value: '110304'}, 
{text: 'ICA/NAZCA/NAZCA', value: '110301'}, 
{text: 'ICA/NAZCA/VISTA ALEGRE', value: '110305'}, 
{text: 'ICA/PALPA/HUANCANO', value: '110402'}, 
{text: 'ICA/PALPA/HUMAY', value: '110403'}, 
{text: 'ICA/PALPA/INDEPENDENCIA', value: '110404'}, 
{text: 'ICA/PALPA/PARACAS', value: '110405'}, 
{text: 'ICA/PALPA/PISCO', value: '110401'}, 
{text: 'ICA/PALPA/SAN ANDRES', value: '110406'}, 
{text: 'ICA/PALPA/SAN CLEMENTE', value: '110407'}, 
{text: 'ICA/PALPA/TUPAC AMARU INCA', value: '110408'}, 
{text: 'ICA/PISCO/LLIPATA', value: '110502'}, 
{text: 'ICA/PISCO/PALPA', value: '110501'}, 
{text: 'ICA/PISCO/RIO GRANDE', value: '110503'}, 
{text: 'ICA/PISCO/SANTA CRUZ', value: '110504'}, 
{text: 'ICA/PISCO/TIBILLO', value: '110505'}, 
{text: 'JUNIN/CHANCHAMAYO/ACOLLA', value: '120302'}, 
{text: 'JUNIN/CHANCHAMAYO/APATA', value: '120303'}, 
{text: 'JUNIN/CHANCHAMAYO/ATAURA', value: '120304'}, 
{text: 'JUNIN/CHANCHAMAYO/CANCHAILLO', value: '120305'}, 
{text: 'JUNIN/CHANCHAMAYO/CURICACA', value: '120331'}, 
{text: 'JUNIN/CHANCHAMAYO/EL MANTARO', value: '120306'}, 
{text: 'JUNIN/CHANCHAMAYO/HUAMALI', value: '120307'}, 
{text: 'JUNIN/CHANCHAMAYO/HUARIPAMPA', value: '120308'}, 
{text: 'JUNIN/CHANCHAMAYO/HUERTAS', value: '120309'}, 
{text: 'JUNIN/CHANCHAMAYO/JANJAILLO', value: '120310'}, 
{text: 'JUNIN/CHANCHAMAYO/JAUJA', value: '120301'}, 
{text: 'JUNIN/CHANCHAMAYO/JULCAN', value: '120311'}, 
{text: 'JUNIN/CHANCHAMAYO/LEONOR ORDONEZ', value: '120312'}, 
{text: 'JUNIN/CHANCHAMAYO/LLOCLLAPAMPA', value: '120313'}, 
{text: 'JUNIN/CHANCHAMAYO/MARCO', value: '120314'}, 
{text: 'JUNIN/CHANCHAMAYO/MASMA', value: '120315'}, 
{text: 'JUNIN/CHANCHAMAYO/MASMA CHICCHE', value: '120332'}, 
{text: 'JUNIN/CHANCHAMAYO/MOLINOS', value: '120316'}, 
{text: 'JUNIN/CHANCHAMAYO/MONOBAMBA', value: '120317'}, 
{text: 'JUNIN/CHANCHAMAYO/MUQUI', value: '120318'}, 
{text: 'JUNIN/CHANCHAMAYO/MUQUIYAUYO', value: '120319'}, 
{text: 'JUNIN/CHANCHAMAYO/PACA', value: '120320'}, 
{text: 'JUNIN/CHANCHAMAYO/PACCHA', value: '120321'}, 
{text: 'JUNIN/CHANCHAMAYO/PANCAN', value: '120322'}, 
{text: 'JUNIN/CHANCHAMAYO/PARCO', value: '120323'}, 
{text: 'JUNIN/CHANCHAMAYO/POMACANCHA', value: '120324'}, 
{text: 'JUNIN/CHANCHAMAYO/RICRAN', value: '120325'}, 
{text: 'JUNIN/CHANCHAMAYO/SAN LORENZO', value: '120326'}, 
{text: 'JUNIN/CHANCHAMAYO/SAN PEDRO DE CHUNAN', value: '120327'}, 
{text: 'JUNIN/CHANCHAMAYO/SAUSA', value: '120333'}, 
{text: 'JUNIN/CHANCHAMAYO/SINCOS', value: '120328'}, 
{text: 'JUNIN/CHANCHAMAYO/TUNAN MARCA', value: '120329'}, 
{text: 'JUNIN/CHANCHAMAYO/YAULI', value: '120330'}, 
{text: 'JUNIN/CHANCHAMAYO/YAUYOS', value: '120334'}, 
{text: 'JUNIN/CHUPACA/AHUAC', value: '120902'}, 
{text: 'JUNIN/CHUPACA/CHONGOS BAJO', value: '120903'}, 
{text: 'JUNIN/CHUPACA/CHUPACA', value: '120901'}, 
{text: 'JUNIN/CHUPACA/HUACHAC', value: '120904'}, 
{text: 'JUNIN/CHUPACA/HUAMANCACA CHICO', value: '120905'}, 
{text: 'JUNIN/CHUPACA/SAN JUAN DE ISCOS', value: '120906'}, 
{text: 'JUNIN/CHUPACA/SAN JUAN DE JARPA', value: '120907'}, 
{text: 'JUNIN/CHUPACA/TRES DE DICIEMBRE', value: '120908'}, 
{text: 'JUNIN/CHUPACA/YANACANCHA', value: '120909'}, 
{text: 'JUNIN/CONCEPCION/ACO', value: '120202'}, 
{text: 'JUNIN/CONCEPCION/ANDAMARCA', value: '120203'}, 
{text: 'JUNIN/CONCEPCION/CHAMBARA', value: '120206'}, 
{text: 'JUNIN/CONCEPCION/COCHAS ', value: '120205'}, 
{text: 'JUNIN/CONCEPCION/COMAS', value: '120204'}, 
{text: 'JUNIN/CONCEPCION/CONCEPCION', value: '120201'}, 
{text: 'JUNIN/CONCEPCION/HEROINAS TOLEDO', value: '120207'}, 
{text: 'JUNIN/CONCEPCION/MANZANARES', value: '120208'}, 
{text: 'JUNIN/CONCEPCION/MATAHUASI', value: '120210'}, 
{text: 'JUNIN/CONCEPCION/MCAL CASTILLA', value: '120209'}, 
{text: 'JUNIN/CONCEPCION/MITO', value: '120211'}, 
{text: 'JUNIN/CONCEPCION/NUEVE DE JULIO', value: '120212'}, 
{text: 'JUNIN/CONCEPCION/ORCOTUNA', value: '120213'}, 
{text: 'JUNIN/CONCEPCION/SAN JOSE DE QUERO', value: '120215'}, 
{text: 'JUNIN/CONCEPCION/STA ROSA DE OCOPA', value: '120214'}, 
{text: 'JUNIN/HUANCAYO/CARHUACALLANGA', value: '120103'}, 
{text: 'JUNIN/HUANCAYO/CHACAPAMPA', value: '120106'}, 
{text: 'JUNIN/HUANCAYO/CHICCHE', value: '120107'}, 
{text: 'JUNIN/HUANCAYO/CHILCA', value: '120108'}, 
{text: 'JUNIN/HUANCAYO/CHONGOS ALTO', value: '120109'}, 
{text: 'JUNIN/HUANCAYO/CHUPURO', value: '120112'}, 
{text: 'JUNIN/HUANCAYO/COLCA', value: '120104'}, 
{text: 'JUNIN/HUANCAYO/CULLHUAS', value: '120105'}, 
{text: 'JUNIN/HUANCAYO/EL TAMBO', value: '120113'}, 
{text: 'JUNIN/HUANCAYO/HUACRAPUQUIO', value: '120114'}, 
{text: 'JUNIN/HUANCAYO/HUALHUAS', value: '120116'}, 
{text: 'JUNIN/HUANCAYO/HUANCAN', value: '120118'}, 
{text: 'JUNIN/HUANCAYO/HUANCAYO', value: '120101'}, 
{text: 'JUNIN/HUANCAYO/HUASICANCHA', value: '120119'}, 
{text: 'JUNIN/HUANCAYO/HUAYUCACHI', value: '120120'}, 
{text: 'JUNIN/HUANCAYO/INGENIO', value: '120121'}, 
{text: 'JUNIN/HUANCAYO/PARIAHUANCA', value: '120122'}, 
{text: 'JUNIN/HUANCAYO/PILCOMAYO', value: '120123'}, 
{text: 'JUNIN/HUANCAYO/PUCARA', value: '120124'}, 
{text: 'JUNIN/HUANCAYO/QUICHUAY', value: '120125'}, 
{text: 'JUNIN/HUANCAYO/QUILCAS', value: '120126'}, 
{text: 'JUNIN/HUANCAYO/SAN AGUSTIN', value: '120127'}, 
{text: 'JUNIN/HUANCAYO/SAN JERONIMO DE TUNAN', value: '120128'}, 
{text: 'JUNIN/HUANCAYO/SANO', value: '120132'}, 
{text: 'JUNIN/HUANCAYO/SAPALLANGA', value: '120133'}, 
{text: 'JUNIN/HUANCAYO/SICAYA', value: '120134'}, 
{text: 'JUNIN/HUANCAYO/STO DOMINGO DE ACOBAMBA', value: '120131'}, 
{text: 'JUNIN/HUANCAYO/VIQUES', value: '120136'}, 
{text: 'JUNIN/JAUJA/CARHUAMAYO', value: '120402'}, 
{text: 'JUNIN/JAUJA/JUNIN', value: '120401'}, 
{text: 'JUNIN/JAUJA/ONDORES', value: '120403'}, 
{text: 'JUNIN/JAUJA/ULCUMAYO', value: '120404'}, 
{text: 'JUNIN/JUNIN/ACOBAMBA', value: '120502'}, 
{text: 'JUNIN/JUNIN/HUARICOLCA', value: '120503'}, 
{text: 'JUNIN/JUNIN/HUASAHUASI', value: '120504'}, 
{text: 'JUNIN/JUNIN/LA UNION', value: '120505'}, 
{text: 'JUNIN/JUNIN/PALCA', value: '120506'}, 
{text: 'JUNIN/JUNIN/PALCAMAYO', value: '120507'}, 
{text: 'JUNIN/JUNIN/SAN PEDRO DE CAJAS', value: '120508'}, 
{text: 'JUNIN/JUNIN/TAPO', value: '120509'}, 
{text: 'JUNIN/JUNIN/TARMA', value: '120501'}, 
{text: 'JUNIN/SATIPO/CHACAPALPA', value: '120602'}, 
{text: 'JUNIN/SATIPO/HUAY HUAY', value: '120603'}, 
{text: 'JUNIN/SATIPO/LA OROYA', value: '120601'}, 
{text: 'JUNIN/SATIPO/MARCAPOMACOCHA', value: '120604'}, 
{text: 'JUNIN/SATIPO/MOROCOCHA', value: '120605'}, 
{text: 'JUNIN/SATIPO/PACCHA', value: '120606'}, 
{text: 'JUNIN/SATIPO/STA BARBARA DE CARHUACAYAN', value: '120607'}, 
{text: 'JUNIN/SATIPO/STA ROSA DE SACCO', value: '120610'}, 
{text: 'JUNIN/SATIPO/SUITUCANCHA', value: '120608'}, 
{text: 'JUNIN/SATIPO/YAULI', value: '120609'}, 
{text: 'JUNIN/TARMA/COVIRIALI', value: '120702'}, 
{text: 'JUNIN/TARMA/LLAYLLA', value: '120703'}, 
{text: 'JUNIN/TARMA/MAZAMARI', value: '120704'}, 
{text: 'JUNIN/TARMA/PAMPA HERMOSA', value: '120705'}, 
{text: 'JUNIN/TARMA/PANGOA', value: '120706'}, 
{text: 'JUNIN/TARMA/RIO NEGRO', value: '120707'}, 
{text: 'JUNIN/TARMA/RIO TAMBO', value: '120708'}, 
{text: 'JUNIN/TARMA/SATIPO', value: '120701'}, 
{text: 'JUNIN/YAULI/CHANCHAMAYO', value: '120801'}, 
{text: 'JUNIN/YAULI/PERENE', value: '120806'}, 
{text: 'JUNIN/YAULI/PICHANAQUI', value: '120805'}, 
{text: 'JUNIN/YAULI/SAN LUIS DE SHUARO', value: '120804'}, 
{text: 'JUNIN/YAULI/SAN RAMON', value: '120802'}, 
{text: 'JUNIN/YAULI/VITOC', value: '120803'}, 
{text: 'LA LIBERTAD/ASCOPE/BAMBAMARCA', value: '130202'}, 
{text: 'LA LIBERTAD/ASCOPE/BOLIVAR', value: '130201'}, 
{text: 'LA LIBERTAD/ASCOPE/CONDORMARCA', value: '130203'}, 
{text: 'LA LIBERTAD/ASCOPE/LONGOTEA', value: '130204'}, 
{text: 'LA LIBERTAD/ASCOPE/UCHUMARCA', value: '130206'}, 
{text: 'LA LIBERTAD/ASCOPE/UCUNCHA', value: '130205'}, 
{text: 'LA LIBERTAD/BOLIVAR/CHUGAY', value: '130304'}, 
{text: 'LA LIBERTAD/BOLIVAR/COCHORCO', value: '130302'}, 
{text: 'LA LIBERTAD/BOLIVAR/CURGOS', value: '130303'}, 
{text: 'LA LIBERTAD/BOLIVAR/HUAMACHUCO', value: '130301'}, 
{text: 'LA LIBERTAD/BOLIVAR/MARCABAL', value: '130305'}, 
{text: 'LA LIBERTAD/BOLIVAR/SANAGORAN', value: '130306'}, 
{text: 'LA LIBERTAD/BOLIVAR/SARIN', value: '130307'}, 
{text: 'LA LIBERTAD/BOLIVAR/SARTIMBAMBA', value: '130308'}, 
{text: 'LA LIBERTAD/CHEPEN/AGALLPAMPA', value: '130402'}, 
{text: 'LA LIBERTAD/CHEPEN/CHARAT', value: '130403'}, 
{text: 'LA LIBERTAD/CHEPEN/HUARANCHAL', value: '130404'}, 
{text: 'LA LIBERTAD/CHEPEN/LA CUESTA', value: '130405'}, 
{text: 'LA LIBERTAD/CHEPEN/MACHE', value: '130413'}, 
{text: 'LA LIBERTAD/CHEPEN/OTUZCO', value: '130401'}, 
{text: 'LA LIBERTAD/CHEPEN/PARANDAY', value: '130408'}, 
{text: 'LA LIBERTAD/CHEPEN/SALPO', value: '130409'}, 
{text: 'LA LIBERTAD/CHEPEN/SINSICAP', value: '130410'}, 
{text: 'LA LIBERTAD/CHEPEN/USQUIL', value: '130411'}, 
{text: 'LA LIBERTAD/GRAN CHIMU/CASCAS', value: '131101'}, 
{text: 'LA LIBERTAD/GRAN CHIMU/LUCMA', value: '131102'}, 
{text: 'LA LIBERTAD/GRAN CHIMU/MARMOT', value: '131103'}, 
{text: 'LA LIBERTAD/GRAN CHIMU/SAYAPULLO', value: '131104'}, 
{text: 'LA LIBERTAD/JULCAN/GUADALUPE', value: '130503'}, 
{text: 'LA LIBERTAD/JULCAN/JEQUETEPEQUE', value: '130504'}, 
{text: 'LA LIBERTAD/JULCAN/PACASMAYO', value: '130506'}, 
{text: 'LA LIBERTAD/JULCAN/SAN JOSE', value: '130508'}, 
{text: 'LA LIBERTAD/JULCAN/SAN PEDRO DE LLOC', value: '130501'}, 
{text: 'LA LIBERTAD/OTUZCO/BULDIBUYO', value: '130602'}, 
{text: 'LA LIBERTAD/OTUZCO/CHILLIA', value: '130603'}, 
{text: 'LA LIBERTAD/OTUZCO/HUANCASPATA', value: '130605'}, 
{text: 'LA LIBERTAD/OTUZCO/HUAYLILLAS', value: '130604'}, 
{text: 'LA LIBERTAD/OTUZCO/HUAYO', value: '130606'}, 
{text: 'LA LIBERTAD/OTUZCO/ONGON', value: '130607'}, 
{text: 'LA LIBERTAD/OTUZCO/PARCOY', value: '130608'}, 
{text: 'LA LIBERTAD/OTUZCO/PATAZ', value: '130609'}, 
{text: 'LA LIBERTAD/OTUZCO/PIAS', value: '130610'}, 
{text: 'LA LIBERTAD/OTUZCO/SANTIAGO DE CHALLAS', value: '130613'}, 
{text: 'LA LIBERTAD/OTUZCO/TAURIJA', value: '130611'}, 
{text: 'LA LIBERTAD/OTUZCO/TAYABAMBA', value: '130601'}, 
{text: 'LA LIBERTAD/OTUZCO/URPAY', value: '130612'}, 
{text: 'LA LIBERTAD/PACASMAYO/ANGASMARCA', value: '130708'}, 
{text: 'LA LIBERTAD/PACASMAYO/CACHICADAN', value: '130702'}, 
{text: 'LA LIBERTAD/PACASMAYO/MOLLEBAMBA', value: '130703'}, 
{text: 'LA LIBERTAD/PACASMAYO/MOLLEPATA', value: '130704'}, 
{text: 'LA LIBERTAD/PACASMAYO/QUIRUVILCA', value: '130705'}, 
{text: 'LA LIBERTAD/PACASMAYO/SANTA CRUZ DE CHUCA', value: '130706'}, 
{text: 'LA LIBERTAD/PACASMAYO/SANTIAGO DE CHUCO', value: '130701'}, 
{text: 'LA LIBERTAD/PACASMAYO/SITABAMBA', value: '130707'}, 
{text: 'LA LIBERTAD/PATAZ/ASCOPE', value: '130801'}, 
{text: 'LA LIBERTAD/PATAZ/CASA GRANDE', value: '130808'}, 
{text: 'LA LIBERTAD/PATAZ/CHICAMA', value: '130802'}, 
{text: 'LA LIBERTAD/PATAZ/CHOCOPE', value: '130803'}, 
{text: 'LA LIBERTAD/PATAZ/MAGDALENA DE CAO', value: '130805'}, 
{text: 'LA LIBERTAD/PATAZ/PAIJAN', value: '130806'}, 
{text: 'LA LIBERTAD/PATAZ/RAZURI', value: '130807'}, 
{text: 'LA LIBERTAD/PATAZ/SANTIAGO DE CAO', value: '130804'}, 
{text: 'LA LIBERTAD/SANCHEZ CARRION/CHEPEN', value: '130901'}, 
{text: 'LA LIBERTAD/SANCHEZ CARRION/PACANGA', value: '130902'}, 
{text: 'LA LIBERTAD/SANCHEZ CARRION/PUEBLO NUEVO', value: '130903'}, 
{text: 'LA LIBERTAD/SANTIAGO DE CHUCO/CALAMARCA', value: '131003'}, 
{text: 'LA LIBERTAD/SANTIAGO DE CHUCO/CARABAMBA', value: '131002'}, 
{text: 'LA LIBERTAD/SANTIAGO DE CHUCO/HUASO', value: '131004'}, 
{text: 'LA LIBERTAD/SANTIAGO DE CHUCO/JULCAN', value: '131001'}, 
{text: 'LA LIBERTAD/TRUJILLO/EL PORVENIR', value: '130110'}, 
{text: 'LA LIBERTAD/TRUJILLO/FLORENCIA DE MORA', value: '130112'}, 
{text: 'LA LIBERTAD/TRUJILLO/HUANCHACO', value: '130102'}, 
{text: 'LA LIBERTAD/TRUJILLO/LA ESPERANZA', value: '130111'}, 
{text: 'LA LIBERTAD/TRUJILLO/LAREDO', value: '130103'}, 
{text: 'LA LIBERTAD/TRUJILLO/MOCHE', value: '130104'}, 
{text: 'LA LIBERTAD/TRUJILLO/POROTO', value: '130109'}, 
{text: 'LA LIBERTAD/TRUJILLO/SALAVERRY', value: '130105'}, 
{text: 'LA LIBERTAD/TRUJILLO/SIMBAL', value: '130106'}, 
{text: 'LA LIBERTAD/TRUJILLO/TRUJILLO', value: '130101'}, 
{text: 'LA LIBERTAD/TRUJILLO/VICTOR LARCO HERRERA', value: '130107'}, 
{text: 'LA LIBERTAD/VIRU/CHAO', value: '131202'}, 
{text: 'LA LIBERTAD/VIRU/GUADALUPITO', value: '131203'}, 
{text: 'LA LIBERTAD/VIRU/VIRU', value: '131201'}, 
{text: 'LAMBAYEQUE/CHICLAYO/CAYALTI', value: '140116'}, 
{text: 'LAMBAYEQUE/CHICLAYO/CHICLAYO', value: '140101'}, 
{text: 'LAMBAYEQUE/CHICLAYO/CHONGOYAPE', value: '140102'}, 
{text: 'LAMBAYEQUE/CHICLAYO/ETEN', value: '140103'}, 
{text: 'LAMBAYEQUE/CHICLAYO/ETEN PUERTO', value: '140104'}, 
{text: 'LAMBAYEQUE/CHICLAYO/JOSE LEONARDO ORTIZ', value: '140112'}, 
{text: 'LAMBAYEQUE/CHICLAYO/LA VICTORIA', value: '140115'}, 
{text: 'LAMBAYEQUE/CHICLAYO/LAGUNAS', value: '140105'}, 
{text: 'LAMBAYEQUE/CHICLAYO/MONSEFU', value: '140106'}, 
{text: 'LAMBAYEQUE/CHICLAYO/NUEVA ARICA', value: '140107'}, 
{text: 'LAMBAYEQUE/CHICLAYO/OYOTUN', value: '140108'}, 
{text: 'LAMBAYEQUE/CHICLAYO/PATAPO', value: '140117'}, 
{text: 'LAMBAYEQUE/CHICLAYO/PICSI', value: '140109'}, 
{text: 'LAMBAYEQUE/CHICLAYO/PIMENTEL', value: '140110'}, 
{text: 'LAMBAYEQUE/CHICLAYO/POMALCA', value: '140118'}, 
{text: 'LAMBAYEQUE/CHICLAYO/PUCALA', value: '140119'}, 
{text: 'LAMBAYEQUE/CHICLAYO/REQUE', value: '140111'}, 
{text: 'LAMBAYEQUE/CHICLAYO/SANA', value: '140114'}, 
{text: 'LAMBAYEQUE/CHICLAYO/SANTA ROSA', value: '140113'}, 
{text: 'LAMBAYEQUE/CHICLAYO/TUMAN', value: '140120'}, 
{text: 'LAMBAYEQUE/FERREÐAFE/CANARIS', value: '140203'}, 
{text: 'LAMBAYEQUE/FERREÐAFE/FERRENAFE', value: '140201'}, 
{text: 'LAMBAYEQUE/FERREÐAFE/INCAHUASI', value: '140202'}, 
{text: 'LAMBAYEQUE/FERREÐAFE/MANUEL ANTONIO MESONES MURO', value: '140206'}, 
{text: 'LAMBAYEQUE/FERREÐAFE/PITIPO', value: '140204'}, 
{text: 'LAMBAYEQUE/FERREÐAFE/PUEBLO NUEVO', value: '140205'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/CHOCHOPE', value: '140302'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/ILLIMO', value: '140303'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/JAYANCA', value: '140304'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/LAMBAYEQUE', value: '140301'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/MOCHUMI', value: '140305'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/MORROPE', value: '140306'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/MOTUPE', value: '140307'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/OLMOS', value: '140308'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/PACORA', value: '140309'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/SALAS', value: '140310'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/SAN JOSE', value: '140311'}, 
{text: 'LAMBAYEQUE/LAMBAYEQUE/TUCUME', value: '140312'}, 
{text: 'LIMA/BARRANCA/CAJATAMBO', value: '150201'}, 
{text: 'LIMA/BARRANCA/COPA', value: '150205'}, 
{text: 'LIMA/BARRANCA/GORGOR', value: '150206'}, 
{text: 'LIMA/BARRANCA/HUANCAPON', value: '150207'}, 
{text: 'LIMA/BARRANCA/MANAS', value: '150208'}, 
{text: 'LIMA/CAÐETE/AMBAR', value: '150502'}, 
{text: 'LIMA/CAÐETE/CALETA DE CARQUIN', value: '150504'}, 
{text: 'LIMA/CAÐETE/CHECRAS', value: '150505'}, 
{text: 'LIMA/CAÐETE/HUACHO', value: '150501'}, 
{text: 'LIMA/CAÐETE/HUALMAY', value: '150506'}, 
{text: 'LIMA/CAÐETE/HUAURA', value: '150507'}, 
{text: 'LIMA/CAÐETE/LEONCIO PRADO', value: '150508'}, 
{text: 'LIMA/CAÐETE/PACCHO', value: '150509'}, 
{text: 'LIMA/CAÐETE/SANTA LEONOR', value: '150511'}, 
{text: 'LIMA/CAÐETE/SANTA MARIA', value: '150512'}, 
{text: 'LIMA/CAÐETE/SAYAN', value: '150513'}, 
{text: 'LIMA/CAÐETE/VEGUETA', value: '150516'}, 
{text: 'LIMA/CAJATAMBO/ARAHUAY', value: '150302'}, 
{text: 'LIMA/CAJATAMBO/CANTA', value: '150301'}, 
{text: 'LIMA/CAJATAMBO/HUAMANTANGA', value: '150303'}, 
{text: 'LIMA/CAJATAMBO/HUAROS', value: '150304'}, 
{text: 'LIMA/CAJATAMBO/LACHAQUI', value: '150305'}, 
{text: 'LIMA/CAJATAMBO/SAN BUENAVENTURA', value: '150306'}, 
{text: 'LIMA/CAJATAMBO/SANTA ROSA DE QUIVES', value: '150307'}, 
{text: 'LIMA/CANTA/ASIA', value: '150416'}, 
{text: 'LIMA/CANTA/CALANGO', value: '150402'}, 
{text: 'LIMA/CANTA/CERRO AZUL', value: '150403'}, 
{text: 'LIMA/CANTA/CHILCA', value: '150405'}, 
{text: 'LIMA/CANTA/COAYLLO', value: '150404'}, 
{text: 'LIMA/CANTA/IMPERIAL', value: '150406'}, 
{text: 'LIMA/CANTA/LUNAHUANA', value: '150407'}, 
{text: 'LIMA/CANTA/MALA', value: '150408'}, 
{text: 'LIMA/CANTA/NUEVO IMPERIAL', value: '150409'}, 
{text: 'LIMA/CANTA/PACARAN', value: '150410'}, 
{text: 'LIMA/CANTA/QUILMANA', value: '150411'}, 
{text: 'LIMA/CANTA/SAN ANTONIO', value: '150412'}, 
{text: 'LIMA/CANTA/SAN LUIS', value: '150413'}, 
{text: 'LIMA/CANTA/SAN VICENTE DE CANETE', value: '150401'}, 
{text: 'LIMA/CANTA/SANTA CRUZ DE FLORES', value: '150414'}, 
{text: 'LIMA/CANTA/ZUNIGA', value: '150415'}, 
{text: 'LIMA/HUARAL/ANTIOQUIA', value: '150602'}, 
{text: 'LIMA/HUARAL/CALLAHUANCA', value: '150603'}, 
{text: 'LIMA/HUARAL/CARAMPOMA', value: '150604'}, 
{text: 'LIMA/HUARAL/CASTA', value: '150605'}, 
{text: 'LIMA/HUARAL/CHICLA', value: '150607'}, 
{text: 'LIMA/HUARAL/CUENCA', value: '150606'}, 
{text: 'LIMA/HUARAL/HUACHUPAMPA', value: '150630'}, 
{text: 'LIMA/HUARAL/HUANZA', value: '150608'}, 
{text: 'LIMA/HUARAL/HUAROCHIRI', value: '150609'}, 
{text: 'LIMA/HUARAL/LAHUAYTAMBO', value: '150610'}, 
{text: 'LIMA/HUARAL/LANGA', value: '150611'}, 
{text: 'LIMA/HUARAL/LARAOS', value: '150631'}, 
{text: 'LIMA/HUARAL/MARIATANA', value: '150612'}, 
{text: 'LIMA/HUARAL/MATUCANA', value: '150601'}, 
{text: 'LIMA/HUARAL/RICARDO PALMA', value: '150613'}, 
{text: 'LIMA/HUARAL/SAN ANDRES DE TUPICOCHA', value: '150614'}, 
{text: 'LIMA/HUARAL/SAN ANTONIO', value: '150615'}, 
{text: 'LIMA/HUARAL/SAN BARTOLOME', value: '150616'}, 
{text: 'LIMA/HUARAL/SAN DAMIAN', value: '150617'}, 
{text: 'LIMA/HUARAL/SAN JUAN DE IRIS ', value: '150632'}, 
{text: 'LIMA/HUARAL/SAN JUAN DE TANTARANCHE', value: '150619'}, 
{text: 'LIMA/HUARAL/SAN LORENZO DE QUINTI', value: '150620'}, 
{text: 'LIMA/HUARAL/SAN MATEO', value: '150621'}, 
{text: 'LIMA/HUARAL/SAN MATEO DE OTAO', value: '150622'}, 
{text: 'LIMA/HUARAL/SAN PEDRO DE HUANCAYRE', value: '150623'}, 
{text: 'LIMA/HUARAL/SANGALLAYA', value: '150618'}, 
{text: 'LIMA/HUARAL/SANTA CRUZ DE COCACHACRA', value: '150624'}, 
{text: 'LIMA/HUARAL/SANTA EULALIA', value: '150625'}, 
{text: 'LIMA/HUARAL/SANTIAGO DE ANCHUCAYA', value: '150626'}, 
{text: 'LIMA/HUARAL/SANTIAGO DE TUNA ', value: '150627'}, 
{text: 'LIMA/HUARAL/SANTO DOMINGO DE LOS OLLEROS', value: '150628'}, 
{text: 'LIMA/HUARAL/SURCO', value: '150629'}, 
{text: 'LIMA/HUAROCHIRI/ALIS', value: '150702'}, 
{text: 'LIMA/HUAROCHIRI/AYAUCA', value: '150703'}, 
{text: 'LIMA/HUAROCHIRI/AYAVIRI', value: '150704'}, 
{text: 'LIMA/HUAROCHIRI/AZANGARO', value: '150705'}, 
{text: 'LIMA/HUAROCHIRI/CACRA', value: '150706'}, 
{text: 'LIMA/HUAROCHIRI/CARANIA', value: '150707'}, 
{text: 'LIMA/HUAROCHIRI/CATAHUASI', value: '150733'}, 
{text: 'LIMA/HUAROCHIRI/CHOCOS', value: '150710'}, 
{text: 'LIMA/HUAROCHIRI/COCHAS', value: '150708'}, 
{text: 'LIMA/HUAROCHIRI/COLONIA', value: '150709'}, 
{text: 'LIMA/HUAROCHIRI/HONGOS', value: '150730'}, 
{text: 'LIMA/HUAROCHIRI/HUAMPARA', value: '150711'}, 
{text: 'LIMA/HUAROCHIRI/HUANCAYA', value: '150712'}, 
{text: 'LIMA/HUAROCHIRI/HUANEC', value: '150715'}, 
{text: 'LIMA/HUAROCHIRI/HUANGASCAR', value: '150713'}, 
{text: 'LIMA/HUAROCHIRI/HUANTAN', value: '150714'}, 
{text: 'LIMA/HUAROCHIRI/LARAOS', value: '150716'}, 
{text: 'LIMA/HUAROCHIRI/LINCHA', value: '150717'}, 
{text: 'LIMA/HUAROCHIRI/MADEAN', value: '150731'}, 
{text: 'LIMA/HUAROCHIRI/MIRAFLORES', value: '150718'}, 
{text: 'LIMA/HUAROCHIRI/OMAS', value: '150719'}, 
{text: 'LIMA/HUAROCHIRI/PUTINZA', value: '150732'}, 
{text: 'LIMA/HUAROCHIRI/QUINCHES', value: '150720'}, 
{text: 'LIMA/HUAROCHIRI/QUINOCAY', value: '150721'}, 
{text: 'LIMA/HUAROCHIRI/SAN JOAQUIN', value: '150722'}, 
{text: 'LIMA/HUAROCHIRI/SAN PEDRO DE PILAS', value: '150723'}, 
{text: 'LIMA/HUAROCHIRI/TANTA', value: '150724'}, 
{text: 'LIMA/HUAROCHIRI/TAURIPAMPA', value: '150725'}, 
{text: 'LIMA/HUAROCHIRI/TOMAS ', value: '150727'}, 
{text: 'LIMA/HUAROCHIRI/TUPE', value: '150726'}, 
{text: 'LIMA/HUAROCHIRI/VINAC', value: '150728'}, 
{text: 'LIMA/HUAROCHIRI/VITIS', value: '150729'}, 
{text: 'LIMA/HUAROCHIRI/YAUYOS', value: '150701'}, 
{text: 'LIMA/HUAURA/ATAVILLOS ALTO', value: '150802'}, 
{text: 'LIMA/HUAURA/ATAVILLOS BAJO', value: '150803'}, 
{text: 'LIMA/HUAURA/AUCALLAMA', value: '150804'}, 
{text: 'LIMA/HUAURA/CHANCAY', value: '150805'}, 
{text: 'LIMA/HUAURA/HUARAL', value: '150801'}, 
{text: 'LIMA/HUAURA/IHUARI', value: '150806'}, 
{text: 'LIMA/HUAURA/LAMPIAN', value: '150807'}, 
{text: 'LIMA/HUAURA/PACARAOS', value: '150808'}, 
{text: 'LIMA/HUAURA/SAN MIGUEL DE ACOS', value: '150809'}, 
{text: 'LIMA/HUAURA/STA CRUZ DE ANDAMARCA', value: '150811'}, 
{text: 'LIMA/HUAURA/SUMBILCA', value: '150812'}, 
{text: 'LIMA/HUAURA/VEINTISIETE DE NOVIEMBRE', value: '150810'}, 
{text: 'LIMA/LIMA/ANCON', value: '150102'}, 
{text: 'LIMA/LIMA/ATE', value: '150103'}, 
{text: 'LIMA/LIMA/BARRANCO', value: '150125'}, 
{text: 'LIMA/LIMA/BRENA', value: '150104'}, 
{text: 'LIMA/LIMA/CARABAYLLO', value: '150105'}, 
{text: 'LIMA/LIMA/CHACLACAYO', value: '150107'}, 
{text: 'LIMA/LIMA/CHORRILLOS', value: '150108'}, 
{text: 'LIMA/LIMA/CIENEGUILLA', value: '150139'}, 
{text: 'LIMA/LIMA/COMAS', value: '150106'}, 
{text: 'LIMA/LIMA/EL AGUSTINO', value: '150135'}, 
{text: 'LIMA/LIMA/INDEPENDENCIA', value: '150134'}, 
{text: 'LIMA/LIMA/JESUS MARIA', value: '150133'}, 
{text: 'LIMA/LIMA/LA MOLINA', value: '150110'}, 
{text: 'LIMA/LIMA/LA VICTORIA', value: '150109'}, 
{text: 'LIMA/LIMA/LIMA', value: '150101'}, 
{text: 'LIMA/LIMA/LINCE', value: '150111'}, 
{text: 'LIMA/LIMA/LOS OLIVOS', value: '150142'}, 
{text: 'LIMA/LIMA/LURIGANCHO', value: '150112'}, 
{text: 'LIMA/LIMA/LURIN', value: '150113'}, 
{text: 'LIMA/LIMA/MAGDALENA DEL MAR', value: '150114'}, 
{text: 'LIMA/LIMA/MIRAFLORES', value: '150115'}, 
{text: 'LIMA/LIMA/PACHACAMAC', value: '150116'}, 
{text: 'LIMA/LIMA/PUCUSANA', value: '150118'}, 
{text: 'LIMA/LIMA/PUEBLO LIBRE', value: '150117'}, 
{text: 'LIMA/LIMA/PUENTE PIEDRA', value: '150119'}, 
{text: 'LIMA/LIMA/PUNTA HERMOSA', value: '150120'}, 
{text: 'LIMA/LIMA/PUNTA NEGRA', value: '150121'}, 
{text: 'LIMA/LIMA/RIMAC', value: '150122'}, 
{text: 'LIMA/LIMA/SAN BARTOLO', value: '150123'}, 
{text: 'LIMA/LIMA/SAN BORJA', value: '150140'}, 
{text: 'LIMA/LIMA/SAN ISIDRO', value: '150124'}, 
{text: 'LIMA/LIMA/SAN JUAN DE LURIGANCHO', value: '150137'}, 
{text: 'LIMA/LIMA/SAN JUAN DE MIRAFLORES', value: '150136'}, 
{text: 'LIMA/LIMA/SAN LUIS', value: '150138'}, 
{text: 'LIMA/LIMA/SAN MARTIN DE PORRES', value: '150126'}, 
{text: 'LIMA/LIMA/SAN MIGUEL', value: '150127'}, 
{text: 'LIMA/LIMA/SANTA ANITA', value: '150143'}, 
{text: 'LIMA/LIMA/SANTA ROSA', value: '150129'}, 
{text: 'LIMA/LIMA/SANTIAGO DE SURCO', value: '150130'}, 
{text: 'LIMA/LIMA/STA MARIA DEL MAR', value: '150128'}, 
{text: 'LIMA/LIMA/SURQUILLO', value: '150131'}, 
{text: 'LIMA/LIMA/VILLA EL SALVADOR', value: '150141'}, 
{text: 'LIMA/LIMA/VILLA MARIA DEL TRIUNFO', value: '150132'}, 
{text: 'LIMA/OYON/BARRANCA', value: '150901'}, 
{text: 'LIMA/OYON/PARAMONGA', value: '150902'}, 
{text: 'LIMA/OYON/PATIVILCA', value: '150903'}, 
{text: 'LIMA/OYON/SUPE', value: '150904'}, 
{text: 'LIMA/OYON/SUPE PUERTO', value: '150905'}, 
{text: 'LIMA/YAUYOS/ANDAJES', value: '151004'}, 
{text: 'LIMA/YAUYOS/CAUJUL', value: '151003'}, 
{text: 'LIMA/YAUYOS/COCHAMARCA', value: '151006'}, 
{text: 'LIMA/YAUYOS/NAVAN', value: '151002'}, 
{text: 'LIMA/YAUYOS/OYON', value: '151001'}, 
{text: 'LIMA/YAUYOS/PACHANGARA', value: '151005'}, 
{text: 'LORETO/ALTO AMAZONAS/BALSAPUERTO', value: '160202'}, 
{text: 'LORETO/ALTO AMAZONAS/JEBEROS', value: '160205'}, 
{text: 'LORETO/ALTO AMAZONAS/LAGUNAS', value: '160206'}, 
{text: 'LORETO/ALTO AMAZONAS/SANTA CRUZ', value: '160210'}, 
{text: 'LORETO/ALTO AMAZONAS/TNTE CESAR LOPEZ ROJAS', value: '160211'}, 
{text: 'LORETO/ALTO AMAZONAS/YURIMAGUAS', value: '160201'}, 
{text: 'LORETO/DATEM DEL MARAÐON/ANDOAS', value: '160702'}, 
{text: 'LORETO/DATEM DEL MARAÐON/BARRANCA', value: '160701'}, 
{text: 'LORETO/DATEM DEL MARAÐON/CAHUAPANAS', value: '160703'}, 
{text: 'LORETO/DATEM DEL MARAÐON/MANSERICHE', value: '160704'}, 
{text: 'LORETO/DATEM DEL MARAÐON/MORONA', value: '160705'}, 
{text: 'LORETO/DATEM DEL MARAÐON/PASTAZA', value: '160706'}, 
{text: 'LORETO/LORETO/NAUTA', value: '160301'}, 
{text: 'LORETO/LORETO/PARINARI', value: '160302'}, 
{text: 'LORETO/LORETO/TIGRE', value: '160302'}, 
{text: 'LORETO/LORETO/TROMPETEROS', value: '160305'}, 
{text: 'LORETO/LORETO/URARINAS', value: '160304'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/ALTO TAPICHE', value: '160402'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/CAPELO', value: '160403'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/EMILIO SAN MARTIN', value: '160404'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/JENARO HERRERA', value: '160410'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/MAQUIA', value: '160405'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/PUINAHUA', value: '160406'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/REQUENA', value: '160401'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/SAQUENA', value: '160407'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/SOPLIN ', value: '160408'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/TAPICHE', value: '160409'}, 
{text: 'LORETO/MARISCAL RAMON CASTILLA/YAQUERANA', value: '160411'}, 
{text: 'LORETO/MAYNAS/ALTO NANAY', value: '160102'}, 
{text: 'LORETO/MAYNAS/BELEN', value: '160112'}, 
{text: 'LORETO/MAYNAS/FERNANDO LORES', value: '160103'}, 
{text: 'LORETO/MAYNAS/INDIANA', value: '160110'}, 
{text: 'LORETO/MAYNAS/IQUITOS', value: '160101'}, 
{text: 'LORETO/MAYNAS/LAS AMAZONAS', value: '160104'}, 
{text: 'LORETO/MAYNAS/MAZAN', value: '160105'}, 
{text: 'LORETO/MAYNAS/NAPO', value: '160106'}, 
{text: 'LORETO/MAYNAS/PUNCHANA', value: '160111'}, 
{text: 'LORETO/MAYNAS/PUTUMAYO', value: '160107'}, 
{text: 'LORETO/MAYNAS/SAN JUAN BAUTISTA', value: '160113'}, 
{text: 'LORETO/MAYNAS/TNTE MANUEL CLAVERO', value: '160114'}, 
{text: 'LORETO/MAYNAS/TORRES CAUSANA', value: '160108'}, 
{text: 'LORETO/REQUENA/CONTAMANA', value: '160501'}, 
{text: 'LORETO/REQUENA/INAHUAYA', value: '160506'}, 
{text: 'LORETO/REQUENA/PADRE MARQUEZ', value: '160503'}, 
{text: 'LORETO/REQUENA/PAMPA HERMOZA', value: '160504'}, 
{text: 'LORETO/REQUENA/SARAYACU', value: '160505'}, 
{text: 'LORETO/REQUENA/VARGAS GUERRA', value: '160502'}, 
{text: 'LORETO/UCAYALI/MARISCAL RAMON CASTILLA', value: '160601'}, 
{text: 'LORETO/UCAYALI/PEBAS', value: '160602'}, 
{text: 'LORETO/UCAYALI/SAN PABLO', value: '160604'}, 
{text: 'LORETO/UCAYALI/YAVARI', value: '160603'}, 
{text: 'MADRE DE DIOS/MANU/FITZCARRALD', value: '170202'}, 
{text: 'MADRE DE DIOS/MANU/HUEPETUHE', value: '170204'}, 
{text: 'MADRE DE DIOS/MANU/MADRE DE DIOS ', value: '170203'}, 
{text: 'MADRE DE DIOS/MANU/MANU', value: '170201'}, 
{text: 'MADRE DE DIOS/TAHUAMANU/IBERIA', value: '170302'}, 
{text: 'MADRE DE DIOS/TAHUAMANU/INAPARI', value: '170301'}, 
{text: 'MADRE DE DIOS/TAHUAMANU/TAHUAMANU', value: '170303'}, 
{text: 'MADRE DE DIOS/TAMBOPATA/INAMBARI', value: '170102'}, 
{text: 'MADRE DE DIOS/TAMBOPATA/LABERINTO', value: '170104'}, 
{text: 'MADRE DE DIOS/TAMBOPATA/LAS PIEDRAS', value: '170103'}, 
{text: 'MADRE DE DIOS/TAMBOPATA/TAMBOPATA', value: '170101'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/CHOJATA', value: '180203'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/COALAQUE', value: '180202'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/ICHUNA', value: '180204'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/LA CAPILLA', value: '180205'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/LLOQUE', value: '180206'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/MATALAQUE', value: '180207'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/OMATE', value: '180201'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/PUQUINA', value: '180208'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/QUINISTAQUILLAS', value: '180209'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/UBINAS', value: '180210'}, 
{text: 'MOQUEGUA/GENERAL SANCHEZ CERRO/YUNGA', value: '180211'}, 
{text: 'MOQUEGUA/ILO/EL ALGARROBAL', value: '180302'}, 
{text: 'MOQUEGUA/ILO/ILO', value: '180301'}, 
{text: 'MOQUEGUA/ILO/PACOCHA', value: '180303'}, 
{text: 'MOQUEGUA/MARISCAL NIETO/CARUMAS', value: '180102'}, 
{text: 'MOQUEGUA/MARISCAL NIETO/CUCHUMBAYA', value: '180103'}, 
{text: 'MOQUEGUA/MARISCAL NIETO/MOQUEGUA', value: '180101'}, 
{text: 'MOQUEGUA/MARISCAL NIETO/SAMEGUA', value: '180106'}, 
{text: 'MOQUEGUA/MARISCAL NIETO/SAN CRISTOBAL', value: '180104'}, 
{text: 'MOQUEGUA/MARISCAL NIETO/TORATA', value: '180105'}, 
{text: 'OTROS/OTROS/OTROS', value: 'NULL'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/CHACAYAN', value: '190202'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/GOYLLARISQUIZGA', value: '190203'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/PAUCAR', value: '190204'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/SAN PEDRO DE PILLAO', value: '190205'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/SANTA ANA DE TUSI', value: '190206'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/TAPUC', value: '190207'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/VILCABAMBA', value: '190208'}, 
{text: 'PASCO/DANIEL ALCIDES CARRION/YANAHUANCA', value: '190201'}, 
{text: 'PASCO/OXAPAMPA/CHONTABAMBA', value: '190302'}, 
{text: 'PASCO/OXAPAMPA/HUANCABAMBA', value: '190303'}, 
{text: 'PASCO/OXAPAMPA/OXAPAMPA', value: '190301'}, 
{text: 'PASCO/OXAPAMPA/PALCAZU', value: '190307'}, 
{text: 'PASCO/OXAPAMPA/POZUZO', value: '190306'}, 
{text: 'PASCO/OXAPAMPA/PUERTO BERMUDEZ', value: '190304'}, 
{text: 'PASCO/OXAPAMPA/VILLA RICA', value: '190305'}, 
{text: 'PASCO/PASCO/CHAUPIMARCA', value: '190101'}, 
{text: 'PASCO/PASCO/HUACHON', value: '190103'}, 
{text: 'PASCO/PASCO/HUARIACA', value: '190104'}, 
{text: 'PASCO/PASCO/HUAYLLAY', value: '190105'}, 
{text: 'PASCO/PASCO/NINACACA', value: '190106'}, 
{text: 'PASCO/PASCO/PALLANCHACRA', value: '190107'}, 
{text: 'PASCO/PASCO/PAUCARTAMBO', value: '190108'}, 
{text: 'PASCO/PASCO/SAN FCO DE ASIS DE YARUSYACAN', value: '190109'}, 
{text: 'PASCO/PASCO/SIMON BOLIVAR', value: '190110'}, 
{text: 'PASCO/PASCO/TICLACAYAN', value: '190111'}, 
{text: 'PASCO/PASCO/TINYAHUARCO', value: '190112'}, 
{text: 'PASCO/PASCO/VICCO', value: '190113'}, 
{text: 'PASCO/PASCO/YANACANCHA', value: '190114'}, 
{text: 'PIURA/AYABACA/AYABACA', value: '200201'}, 
{text: 'PIURA/AYABACA/FRIAS', value: '200202'}, 
{text: 'PIURA/AYABACA/JILILI', value: '200209'}, 
{text: 'PIURA/AYABACA/LAGUNAS', value: '200203'}, 
{text: 'PIURA/AYABACA/MONTERO', value: '200204'}, 
{text: 'PIURA/AYABACA/PACAIPAMPA', value: '200205'}, 
{text: 'PIURA/AYABACA/PAIMAS', value: '200210'}, 
{text: 'PIURA/AYABACA/SAPILLICA', value: '200206'}, 
{text: 'PIURA/AYABACA/SICCHEZ', value: '200207'}, 
{text: 'PIURA/AYABACA/SUYO', value: '200208'}, 
{text: 'PIURA/HUANCABAMBA/CANCHAQUE', value: '200302'}, 
{text: 'PIURA/HUANCABAMBA/EL CARMEN DE LA FRONTERA', value: '200306'}, 
{text: 'PIURA/HUANCABAMBA/HUANCABAMBA', value: '200301'}, 
{text: 'PIURA/HUANCABAMBA/HUARMACA', value: '200303'}, 
{text: 'PIURA/HUANCABAMBA/LALAQUIZ', value: '200308'}, 
{text: 'PIURA/HUANCABAMBA/SAN MIGUEL DE EL FAIQUE', value: '200307'}, 
{text: 'PIURA/HUANCABAMBA/SONDOR', value: '200304'}, 
{text: 'PIURA/HUANCABAMBA/SONDORILLO', value: '200305'}, 
{text: 'PIURA/MORROPON/BUENOS AIRES', value: '200402'}, 
{text: 'PIURA/MORROPON/CHALACO', value: '200403'}, 
{text: 'PIURA/MORROPON/CHULUCANAS', value: '200401'}, 
{text: 'PIURA/MORROPON/LA MATANZA', value: '200408'}, 
{text: 'PIURA/MORROPON/MORROPON', value: '200404'}, 
{text: 'PIURA/MORROPON/SALITRAL', value: '200405'}, 
{text: 'PIURA/MORROPON/SAN JUAN DE BIGOTE', value: '200410'}, 
{text: 'PIURA/MORROPON/SANTA CATALINA DE MOSSA', value: '200406'}, 
{text: 'PIURA/MORROPON/SANTO DOMINGO', value: '200407'}, 
{text: 'PIURA/MORROPON/YAMANGO', value: '200409'}, 
{text: 'PIURA/PAITA/AMOTAPE', value: '200502'}, 
{text: 'PIURA/PAITA/ARENAL', value: '200503'}, 
{text: 'PIURA/PAITA/LA HUACA', value: '200504'}, 
{text: 'PIURA/PAITA/PAITA', value: '200501'}, 
{text: 'PIURA/PAITA/PUEBLO NUEVO DE COLAN', value: '200505'}, 
{text: 'PIURA/PAITA/TAMARINDO', value: '200506'}, 
{text: 'PIURA/PAITA/VICHAYAL', value: '200507'}, 
{text: 'PIURA/PIURA/CASTILLA', value: '200103'}, 
{text: 'PIURA/PIURA/CATACAOS', value: '200104'}, 
{text: 'PIURA/PIURA/CURA MORI', value: '200113'}, 
{text: 'PIURA/PIURA/EL TALLAN', value: '200114'}, 
{text: 'PIURA/PIURA/LA ARENA', value: '200105'}, 
{text: 'PIURA/PIURA/LA UNION', value: '200106'}, 
{text: 'PIURA/PIURA/LAS LOMAS', value: '200107'}, 
{text: 'PIURA/PIURA/PIURA', value: '200101'}, 
{text: 'PIURA/PIURA/TAMBO GRANDE', value: '200109'}, 
{text: 'PIURA/SECHURA/BELLAVISTA DE LA UNION', value: '200804'}, 
{text: 'PIURA/SECHURA/BERNAL', value: '200803'}, 
{text: 'PIURA/SECHURA/CRISTO NOS VALGA', value: '200805'}, 
{text: 'PIURA/SECHURA/RINCONADA LLICUAR', value: '200806'}, 
{text: 'PIURA/SECHURA/SECHURA', value: '200801'}, 
{text: 'PIURA/SECHURA/VICE', value: '200802'}, 
{text: 'PIURA/SULLANA/BELLAVISTA', value: '200602'}, 
{text: 'PIURA/SULLANA/IGNACIO ESCUDERO', value: '200608'}, 
{text: 'PIURA/SULLANA/LANCONES', value: '200603'}, 
{text: 'PIURA/SULLANA/MARCAVELICA', value: '200604'}, 
{text: 'PIURA/SULLANA/MIGUEL CHECA', value: '200605'}, 
{text: 'PIURA/SULLANA/QUERECOTILLO', value: '200606'}, 
{text: 'PIURA/SULLANA/SALITRAL', value: '200607'}, 
{text: 'PIURA/SULLANA/SULLANA', value: '200601'}, 
{text: 'PIURA/TALARA/EL ALTO', value: '200702'}, 
{text: 'PIURA/TALARA/LA BREA', value: '200703'}, 
{text: 'PIURA/TALARA/LOBITOS', value: '200704'}, 
{text: 'PIURA/TALARA/LOS ORGANOS', value: '200706'}, 
{text: 'PIURA/TALARA/MANCORA', value: '200705'}, 
{text: 'PIURA/TALARA/PARINAS', value: '200701'}, 
{text: 'PROV. CONST. DEL CALLAO/PROV. CONST. DEL CALLAO/BELLAVISTA', value: '070102'}, 
{text: 'PROV. CONST. DEL CALLAO/PROV. CONST. DEL CALLAO/CALLAO', value: '070101'}, 
{text: 'PROV. CONST. DEL CALLAO/PROV. CONST. DEL CALLAO/CARMEN DE LA LEGUA-REYNOSO', value: '070104'}, 
{text: 'PROV. CONST. DEL CALLAO/PROV. CONST. DEL CALLAO/LA PERLA', value: '070105'}, 
{text: 'PROV. CONST. DEL CALLAO/PROV. CONST. DEL CALLAO/LA PUNTA', value: '070103'}, 
{text: 'PROV. CONST. DEL CALLAO/PROV. CONST. DEL CALLAO/VENTANILLA', value: '070106'}, 
{text: 'PUNO/AZANGARO/ACHAYA', value: '210202'}, 
{text: 'PUNO/AZANGARO/ARAPA', value: '210203'}, 
{text: 'PUNO/AZANGARO/ASILLO', value: '210204'}, 
{text: 'PUNO/AZANGARO/AZANGARO', value: '210201'}, 
{text: 'PUNO/AZANGARO/CAMINACA', value: '210205'}, 
{text: 'PUNO/AZANGARO/CHUPA', value: '210206'}, 
{text: 'PUNO/AZANGARO/JOSE DOMINGO CHOQUEHUANCA', value: '210207'}, 
{text: 'PUNO/AZANGARO/MUNANI', value: '210208'}, 
{text: 'PUNO/AZANGARO/POTONI', value: '210210'}, 
{text: 'PUNO/AZANGARO/SAMAN', value: '210212'}, 
{text: 'PUNO/AZANGARO/SAN ANTON', value: '210213'}, 
{text: 'PUNO/AZANGARO/SAN JOSE', value: '210214'}, 
{text: 'PUNO/AZANGARO/SAN JUAN DE SALINAS', value: '210215'}, 
{text: 'PUNO/AZANGARO/STGO DE PUPUJA', value: '210216'}, 
{text: 'PUNO/AZANGARO/TIRAPATA', value: '210217'}, 
{text: 'PUNO/CARABAYA/AJOYANI', value: '210302'}, 
{text: 'PUNO/CARABAYA/AYAPATA', value: '210303'}, 
{text: 'PUNO/CARABAYA/COASA', value: '210304'}, 
{text: 'PUNO/CARABAYA/CORANI', value: '210305'}, 
{text: 'PUNO/CARABAYA/CRUCERO', value: '210306'}, 
{text: 'PUNO/CARABAYA/ITUATA', value: '210307'}, 
{text: 'PUNO/CARABAYA/MACUSANI', value: '210301'}, 
{text: 'PUNO/CARABAYA/OLLACHEA', value: '210308'}, 
{text: 'PUNO/CARABAYA/SAN GABAN', value: '210309'}, 
{text: 'PUNO/CARABAYA/USICAYOS', value: '210310'}, 
{text: 'PUNO/CHUCUITO/DESAGUADERO', value: '210402'}, 
{text: 'PUNO/CHUCUITO/HUACULLANI', value: '210403'}, 
{text: 'PUNO/CHUCUITO/JULI', value: '210401'}, 
{text: 'PUNO/CHUCUITO/KELLUYO', value: '210412'}, 
{text: 'PUNO/CHUCUITO/PISACOMA', value: '210406'}, 
{text: 'PUNO/CHUCUITO/POMATA', value: '210407'}, 
{text: 'PUNO/CHUCUITO/ZEPITA', value: '210410'}, 
{text: 'PUNO/EL COLLAO/COJATA', value: '210502'}, 
{text: 'PUNO/EL COLLAO/HUANCANE', value: '210501'}, 
{text: 'PUNO/EL COLLAO/HUATASANI', value: '210511'}, 
{text: 'PUNO/EL COLLAO/INCHUPALLA', value: '210504'}, 
{text: 'PUNO/EL COLLAO/PUSI', value: '210506'}, 
{text: 'PUNO/EL COLLAO/ROSASPATA', value: '210507'}, 
{text: 'PUNO/EL COLLAO/TARACO', value: '210508'}, 
{text: 'PUNO/EL COLLAO/VILQUE CHICO', value: '210509'}, 
{text: 'PUNO/HUANCANE/CABANILLA', value: '210602'}, 
{text: 'PUNO/HUANCANE/CALAPUJA', value: '210603'}, 
{text: 'PUNO/HUANCANE/LAMPA', value: '210601'}, 
{text: 'PUNO/HUANCANE/NICASIO', value: '210604'}, 
{text: 'PUNO/HUANCANE/OCUVIRI', value: '210605'}, 
{text: 'PUNO/HUANCANE/PALCA', value: '210606'}, 
{text: 'PUNO/HUANCANE/PARATIA', value: '210607'}, 
{text: 'PUNO/HUANCANE/PUCARA', value: '210608'}, 
{text: 'PUNO/HUANCANE/SANTA LUCIA', value: '210609'}, 
{text: 'PUNO/HUANCANE/VILAVILA', value: '210610'}, 
{text: 'PUNO/LAMPA/ANTAUTA', value: '210702'}, 
{text: 'PUNO/LAMPA/AYAVIRI', value: '210701'}, 
{text: 'PUNO/LAMPA/CUPI', value: '210703'}, 
{text: 'PUNO/LAMPA/LLALLI', value: '210704'}, 
{text: 'PUNO/LAMPA/MACARI', value: '210705'}, 
{text: 'PUNO/LAMPA/NUNOA', value: '210706'}, 
{text: 'PUNO/LAMPA/ORURILLO', value: '210707'}, 
{text: 'PUNO/LAMPA/SANTA ROSA', value: '210708'}, 
{text: 'PUNO/LAMPA/UMACHIRI', value: '210709'}, 
{text: 'PUNO/MELGAR/ALTO INAMBARI', value: '210811'}, 
{text: 'PUNO/MELGAR/CUYOCUYO', value: '210803'}, 
{text: 'PUNO/MELGAR/LIMBANI', value: '210804'}, 
{text: 'PUNO/MELGAR/PATAMBUCO', value: '210806'}, 
{text: 'PUNO/MELGAR/PHARA', value: '210805'}, 
{text: 'PUNO/MELGAR/QUIACA', value: '210807'}, 
{text: 'PUNO/MELGAR/SAN JUAN DEL ORO', value: '210808'}, 
{text: 'PUNO/MELGAR/SAN PEDRO DE PUTINA PUNCO', value: '210812'}, 
{text: 'PUNO/MELGAR/SANDIA', value: '210801'}, 
{text: 'PUNO/MELGAR/YANAHUAYA', value: '210810'}, 
{text: 'PUNO/MOHO/CABANA', value: '210902'}, 
{text: 'PUNO/MOHO/CABANILLAS', value: '210903'}, 
{text: 'PUNO/MOHO/CARACOTO', value: '210904'}, 
{text: 'PUNO/MOHO/JULIACA', value: '210901'}, 
{text: 'PUNO/PUNO/ACORA', value: '210102'}, 
{text: 'PUNO/PUNO/AMANTANI', value: '210115'}, 
{text: 'PUNO/PUNO/ATUNCOLLA', value: '210103'}, 
{text: 'PUNO/PUNO/CAPACHICA', value: '210104'}, 
{text: 'PUNO/PUNO/CHUCUITO', value: '210106'}, 
{text: 'PUNO/PUNO/COATA', value: '210105'}, 
{text: 'PUNO/PUNO/HUATA', value: '210107'}, 
{text: 'PUNO/PUNO/MANAZO', value: '210108'}, 
{text: 'PUNO/PUNO/PAUCARCOLLA', value: '210109'}, 
{text: 'PUNO/PUNO/PICHACANI', value: '210110'}, 
{text: 'PUNO/PUNO/PLATERIA', value: '210114'}, 
{text: 'PUNO/PUNO/PUNO', value: '210101'}, 
{text: 'PUNO/PUNO/SAN ANTONIO', value: '210111'}, 
{text: 'PUNO/PUNO/TIQUILLACA', value: '210112'}, 
{text: 'PUNO/PUNO/VILQUE', value: '210113'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/ANAPIA', value: '211003'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/COPANI', value: '211004'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/CUTURAPI', value: '211005'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/OLLARAYA', value: '211006'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/TINICACHI', value: '211007'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/UNICACHI', value: '211002'}, 
{text: 'PUNO/SAN ANTONIO DE PUTINA/YUNGUYO', value: '211001'}, 
{text: 'PUNO/SAN ROMAN/ANANEA', value: '211104'}, 
{text: 'PUNO/SAN ROMAN/PEDRO VILCA APAZA', value: '211102'}, 
{text: 'PUNO/SAN ROMAN/PUTINA', value: '211101'}, 
{text: 'PUNO/SAN ROMAN/QUILCA PUNCU', value: '211103'}, 
{text: 'PUNO/SAN ROMAN/SINA', value: '211105'}, 
{text: 'PUNO/SANDIA/CAPASO', value: '211204'}, 
{text: 'PUNO/SANDIA/CONDURIRI', value: '211205'}, 
{text: 'PUNO/SANDIA/ILAVE', value: '211201'}, 
{text: 'PUNO/SANDIA/PILCUYO', value: '211202'}, 
{text: 'PUNO/SANDIA/SANTA ROSA', value: '211203'}, 
{text: 'PUNO/YUNGUYO/CONIMA', value: '211302'}, 
{text: 'PUNO/YUNGUYO/HUAYRAPATA', value: '211304'}, 
{text: 'PUNO/YUNGUYO/MOHO', value: '211301'}, 
{text: 'PUNO/YUNGUYO/TILALI', value: '211303'}, 
{text: 'SAN MARTIN/BELLAVISTA/ALTO SAPOSOA', value: '220205'}, 
{text: 'SAN MARTIN/BELLAVISTA/EL ESLABON', value: '220206'}, 
{text: 'SAN MARTIN/BELLAVISTA/PISCOYACU', value: '220202'}, 
{text: 'SAN MARTIN/BELLAVISTA/SACANCHE', value: '220203'}, 
{text: 'SAN MARTIN/BELLAVISTA/SAPOSOA', value: '220201'}, 
{text: 'SAN MARTIN/BELLAVISTA/TINGO DE SAPOSOA', value: '220204'}, 
{text: 'SAN MARTIN/EL DORADO/ALONSO DE ALVARADO', value: '220315'}, 
{text: 'SAN MARTIN/EL DORADO/BARRANQUITA', value: '220303'}, 
{text: 'SAN MARTIN/EL DORADO/CAYNARACHI', value: '220304'}, 
{text: 'SAN MARTIN/EL DORADO/CUNUMBUQUI', value: '220305'}, 
{text: 'SAN MARTIN/EL DORADO/LAMAS', value: '220301'}, 
{text: 'SAN MARTIN/EL DORADO/PINTO RECODO', value: '220306'}, 
{text: 'SAN MARTIN/EL DORADO/RUMISAPA', value: '220307'}, 
{text: 'SAN MARTIN/EL DORADO/SAN ROQUE DE CUMBAZA', value: '220316'}, 
{text: 'SAN MARTIN/EL DORADO/SHANAO', value: '220311'}, 
{text: 'SAN MARTIN/EL DORADO/TABALOSOS', value: '220313'}, 
{text: 'SAN MARTIN/EL DORADO/ZAPATERO', value: '220314'}, 
{text: 'SAN MARTIN/HUALLAGA/CAMPANILLA', value: '220402'}, 
{text: 'SAN MARTIN/HUALLAGA/HUICUNGO', value: '220403'}, 
{text: 'SAN MARTIN/HUALLAGA/JUANJUI', value: '220401'}, 
{text: 'SAN MARTIN/HUALLAGA/PACHIZA', value: '220404'}, 
{text: 'SAN MARTIN/HUALLAGA/PAJARILLO', value: '220405'}, 
{text: 'SAN MARTIN/LAMAS/AWAJUN', value: '220509'}, 
{text: 'SAN MARTIN/LAMAS/ELIAS SOPLIN', value: '220506'}, 
{text: 'SAN MARTIN/LAMAS/NUEVA CAJAMARCA', value: '220505'}, 
{text: 'SAN MARTIN/LAMAS/PARDO MIGUEL', value: '220508'}, 
{text: 'SAN MARTIN/LAMAS/POSIC', value: '220502'}, 
{text: 'SAN MARTIN/LAMAS/RIOJA', value: '220501'}, 
{text: 'SAN MARTIN/LAMAS/SAN FERNANDO', value: '220507'}, 
{text: 'SAN MARTIN/LAMAS/YORONGOS', value: '220503'}, 
{text: 'SAN MARTIN/LAMAS/YURACYACU', value: '220504'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/ALBERTO LEVEAU', value: '220602'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/CACATACHI', value: '220604'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/CHAZUTA', value: '220606'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/CHIPURANA', value: '220607'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/EL PORVENIR', value: '220608'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/HUIMBAYOC', value: '220609'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/JUAN GUERRA', value: '220610'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/LA BANDA DE SHILCAYO', value: '220621'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/MORALES', value: '220611'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/PAPAPLAYA', value: '220612'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/SAN ANTONIO', value: '220616'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/SAUCE', value: '220619'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/SHAPAJA', value: '220620'}, 
{text: 'SAN MARTIN/MARISCAL CACERES/TARAPOTO', value: '220601'}, 
{text: 'SAN MARTIN/MOYOBAMBA/CALZADA', value: '220102'}, 
{text: 'SAN MARTIN/MOYOBAMBA/HABANA', value: '220103'}, 
{text: 'SAN MARTIN/MOYOBAMBA/JEPELACIO', value: '220104'}, 
{text: 'SAN MARTIN/MOYOBAMBA/MOYOBAMBA', value: '220101'}, 
{text: 'SAN MARTIN/MOYOBAMBA/SORITOR', value: '220105'}, 
{text: 'SAN MARTIN/MOYOBAMBA/YANTALO', value: '220106'}, 
{text: 'SAN MARTIN/PICOTA/ALTO BIAVO', value: '220704'}, 
{text: 'SAN MARTIN/PICOTA/BAJO BIAVO', value: '220706'}, 
{text: 'SAN MARTIN/PICOTA/BELLAVISTA', value: '220701'}, 
{text: 'SAN MARTIN/PICOTA/HUALLAGA', value: '220705'}, 
{text: 'SAN MARTIN/PICOTA/SAN PABLO', value: '220703'}, 
{text: 'SAN MARTIN/PICOTA/SAN RAFAEL', value: '220702'}, 
{text: 'SAN MARTIN/RIOJA/NUEVO PROGRESO', value: '220802'}, 
{text: 'SAN MARTIN/RIOJA/POLVORA', value: '220803'}, 
{text: 'SAN MARTIN/RIOJA/SHUNTE', value: '220804'}, 
{text: 'SAN MARTIN/RIOJA/TOCACHE', value: '220801'}, 
{text: 'SAN MARTIN/RIOJA/UCHIZA', value: '220805'}, 
{text: 'SAN MARTIN/SAN MARTIN/BUENOS AIRES', value: '220902'}, 
{text: 'SAN MARTIN/SAN MARTIN/CASPIZAPA', value: '220903'}, 
{text: 'SAN MARTIN/SAN MARTIN/PICOTA', value: '220901'}, 
{text: 'SAN MARTIN/SAN MARTIN/PILLUANA', value: '220904'}, 
{text: 'SAN MARTIN/SAN MARTIN/PUCACACA', value: '220905'}, 
{text: 'SAN MARTIN/SAN MARTIN/SAN CRISTOBAL', value: '220906'}, 
{text: 'SAN MARTIN/SAN MARTIN/SAN HILARION', value: '220907'}, 
{text: 'SAN MARTIN/SAN MARTIN/SHAMBOYACU', value: '220910'}, 
{text: 'SAN MARTIN/SAN MARTIN/TINGO DE PONASA', value: '220908'}, 
{text: 'SAN MARTIN/SAN MARTIN/TRES UNIDOS', value: '220909'}, 
{text: 'SAN MARTIN/TOCACHE/AGUA BLANCA', value: '221002'}, 
{text: 'SAN MARTIN/TOCACHE/SAN JOSE DE SISA', value: '221001'}, 
{text: 'SAN MARTIN/TOCACHE/SAN MARTIN', value: '221004'}, 
{text: 'SAN MARTIN/TOCACHE/SANTA ROSA', value: '221005'}, 
{text: 'SAN MARTIN/TOCACHE/SHATOJA', value: '221003'}, 
{text: 'TACNA/CANDARAVE/CHUCATAMANI', value: '230205'}, 
{text: 'TACNA/CANDARAVE/ESTIQUE', value: '230206'}, 
{text: 'TACNA/CANDARAVE/ESTIQUE PAMPA', value: '230207'}, 
{text: 'TACNA/CANDARAVE/SITAJARA', value: '230210'}, 
{text: 'TACNA/CANDARAVE/SUSAPAYA', value: '230211'}, 
{text: 'TACNA/CANDARAVE/TARATA', value: '230201'}, 
{text: 'TACNA/CANDARAVE/TARUCACHI', value: '230212'}, 
{text: 'TACNA/CANDARAVE/TICACO', value: '230213'}, 
{text: 'TACNA/JORGE BASADRE/ILABAYA', value: '230303'}, 
{text: 'TACNA/JORGE BASADRE/ITE', value: '230302'}, 
{text: 'TACNA/JORGE BASADRE/LOCUMBA', value: '230301'}, 
{text: 'TACNA/TACNA/ALTO DE LA ALIANZA', value: '230111'}, 
{text: 'TACNA/TACNA/CALANA', value: '230102'}, 
{text: 'TACNA/TACNA/CIUDAD NUEVA', value: '230112'}, 
{text: 'TACNA/TACNA/CRL. GREG. ALBARRACIN LANCHIPA', value: '230113'}, 
{text: 'TACNA/TACNA/INCLAN', value: '230104'}, 
{text: 'TACNA/TACNA/PACHIA', value: '230107'}, 
{text: 'TACNA/TACNA/PALCA', value: '230108'}, 
{text: 'TACNA/TACNA/POCOLLAY', value: '230109'}, 
{text: 'TACNA/TACNA/SAMA', value: '230110'}, 
{text: 'TACNA/TACNA/TACNA', value: '230101'}, 
{text: 'TACNA/TARATA/CAIRANI', value: '230402'}, 
{text: 'TACNA/TARATA/CAMILACA', value: '230406'}, 
{text: 'TACNA/TARATA/CANDARAVE', value: '230401'}, 
{text: 'TACNA/TARATA/CURIBAYA', value: '230403'}, 
{text: 'TACNA/TARATA/HUANUARA', value: '230404'}, 
{text: 'TACNA/TARATA/QUILAHUANI', value: '230405'}, 
{text: 'TUMBES/CONTRALMIRANTE VILLAR/CANOAS DE PUNTA SAL', value: '240203'}, 
{text: 'TUMBES/CONTRALMIRANTE VILLAR/CASITAS', value: '240202'}, 
{text: 'TUMBES/CONTRALMIRANTE VILLAR/ZORRITOS', value: '240201'}, 
{text: 'TUMBES/TUMBES/CORRALES', value: '240102'}, 
{text: 'TUMBES/TUMBES/LA CRUZ', value: '240103'}, 
{text: 'TUMBES/TUMBES/PAMPAS DE HOSPITAL', value: '240104'}, 
{text: 'TUMBES/TUMBES/SAN JACINTO', value: '240105'}, 
{text: 'TUMBES/TUMBES/SAN JUAN DE LA VIRGEN', value: '240106'}, 
{text: 'TUMBES/TUMBES/TUMBES', value: '240101'}, 
{text: 'TUMBES/ZARUMILLA/AGUAS VERDES', value: '240304'}, 
{text: 'TUMBES/ZARUMILLA/MATAPALO', value: '240302'}, 
{text: 'TUMBES/ZARUMILLA/PAPAYAL', value: '240303'}, 
{text: 'TUMBES/ZARUMILLA/ZARUMILLA', value: '240301'}, 
{text: 'UCAYALI/ATALAYA/CURIMANA', value: '250203'}, 
{text: 'UCAYALI/ATALAYA/PADRE ABAD', value: '250201'}, 
{text: 'UCAYALI/ATALAYA/YRAZOLA', value: '250202'}, 
{text: 'UCAYALI/CORONEL PORTILLO/CALLERIA', value: '250101'}, 
{text: 'UCAYALI/CORONEL PORTILLO/CAMPOVERDE', value: '250104'}, 
{text: 'UCAYALI/CORONEL PORTILLO/IPARIA', value: '250105'}, 
{text: 'UCAYALI/CORONEL PORTILLO/MANANTAY', value: '250107'}, 
{text: 'UCAYALI/CORONEL PORTILLO/MASISEA', value: '250103'}, 
{text: 'UCAYALI/CORONEL PORTILLO/NUEVA REQUENA', value: '250106'}, 
{text: 'UCAYALI/CORONEL PORTILLO/YARINACOCHA', value: '250102'}, 
{text: 'UCAYALI/PADRE ABAD/RAIMONDI', value: '250301'}, 
{text: 'UCAYALI/PADRE ABAD/SEPAHUA', value: '250304'}, 
{text: 'UCAYALI/PADRE ABAD/TAHUANIA', value: '250302'}, 
{text: 'UCAYALI/PADRE ABAD/YURUA', value: '250303'}, 
{text: 'UCAYALI/PURUS/PURUS', value: '250401'}],
    }),
    computed: {
        ...mapState(['ssUser']),
        cEdad () {
            if (this.dPriAlumno.FechaNac != ''){
                return "Edad es " + moment().diff(this.dPriAlumno.FechaNac, 'years') + " años";
            }
        },
        cNroDocSizeMax () {
            if (this.dPriAlumno.tipo_documento == 1)
                return 8
            else
                return 12
        },
    },
    methods: {
        fuDateChange (date) {
            this.$refs.menu.save(date)
        },
        async fuAlumno(pIdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!, $token: String){
                        prialumno(IdAlumno:$IdAlumno, token: $token){
                            IdAlumno
                            DNI
                            ApPaterno
                            ApMaterno
                            Nombres
                            Sexo
                            FechaNac
                            Direccion
                            Telefono
                            Codigo
                            Email
                            IdColegio
                            IdVisita
                            DependeEco
                            TipoTrabajo
                            CentroTrabajo
                            DireccionTrabajo
                            IngresoMensual
                            Ocupacion
                            QuienEligioCarrera
                            Celular
                            UbigeoD
                            UbigeoN
                            FechaMod
                            OperModif
                            AnioEgresoSecundaria
                            tipo_documento
                            pricolegio{
                                Nombre
                            }
                            admconfigperiodo{
                                FechaFin
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: pIdAlumno,
                        token: new Date().toISOString()
                    }
                })
                this.dPriAlumno = response.data.prialumno;
                this.dDNI = response.data.prialumno.DNI;
                this.dApPaterno = response.data.prialumno.ApPaterno;
                this.dApMaterno = response.data.prialumno.ApMaterno;
                this.dNombres = response.data.prialumno.Nombres;
                this.dFecNac = response.data.prialumno.FechaNac.substring(0,10);
                this.dPriAlumno.AnioEgresoSecundaria = parseInt(response.data.prialumno.AnioEgresoSecundaria);
                if(response.data.prialumno.pricolegio) this.dPriColegioText = response.data.prialumno.pricolegio.Nombre;

                let vFechaFin = moment(response.data.prialumno.admconfigperiodo.FechaFin).format("YYYY-MM-DD");
                let ahora = moment().format("YYYY-MM-DD");                
                if(ahora > vFechaFin)
                    this.dIsReadOnly = true;
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuAlumnoSave () {
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {                
                this.dPriAlumno.FechaMod = moment().format("YYYYMMDD HH:mm:ss");                
                this.dPriAlumno.OperModif = this.ssUser.Usuario;
                const { __typename, IdAlumno, pricolegio, admconfigperiodo, ...vPriAlumno } = this.dPriAlumno;

                this.fuAlumnoUpdate(vPriAlumno);

                if(this.dDNI!=this.dPriAlumno.DNI)
                    this.fuAlumnoUpdateByDNI();
                if(this.dNombres!=this.dPriAlumno.Nombres || this.dApPaterno!=this.dPriAlumno.ApPaterno || this.dApMaterno!=this.dPriAlumno.ApMaterno)
                    this.fuAlumnoUpdateByNombres();
            }
        },
        async fuAlumnoUpdate (p_PriAlumno) {
            try {
                this.dLoading = true;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoUpdate($IdAlumno: ID!, $input: prialumnoUpdateInput!){
                        prialumnoUpdate(IdAlumno: $IdAlumno, input: $input){
                            IdAlumno
                            ApPaterno
                            ApMaterno
                            Nombres
                            Codigo
                            IdServicio
                            priservicio{
                                Descripcion
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: this.dPriAlumno.IdAlumno,
                        input: p_PriAlumno
                    }
                });
                if(response.data){
                    Swal.fire('Correcto', 'Registro correcto.', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        async fuAlumnoUpdateByDNI () {
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoUpdate2($IdAlumno: ID!, $input: prialumnoUpdateInput!){
                        prialumnoUpdate2(IdAlumno: $IdAlumno, input: $input){
                            message
                        }
                    }`,
                    variables: {
                        IdAlumno: this.pIdAlumno,
                        input: {
                            DNI: this.dPriAlumno.DNI
                        }
                    }
                });
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto DNI.', 'error');
            } finally {
            }
        },
        async fuAlumnoUpdateByNombres () {
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoUpdate2($IdAlumno: ID!, $input: prialumnoUpdateInput!){
                        prialumnoUpdate2(IdAlumno: $IdAlumno, input: $input){
                            message
                        }
                    }`,
                    variables: {
                        IdAlumno: this.pIdAlumno,
                        input: {
                            Nombres: this.dPriAlumno.Nombres,
                            ApPaterno: this.dPriAlumno.ApPaterno,
                            ApMaterno: this.dPriAlumno.ApMaterno
                        }
                    }
                });
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto Nombres.', 'error');
            } finally {
            }
        },
        fuPriColegioSearch(){
            if(!this.$refs.refPriColegio.validate()){
                this.dSnackbar = true;
            } else {
                this.fuPricolegioByNombreByDpto();                
            }
        },
        fuPriColegioSelected(){
            if(!this.dPriColegioTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
            } else {
                if(this.dPriColegioTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
                else{
                    this.dPriAlumno.IdColegio = this.dPriColegioTable.selected[0].IdColegio;
                    this.dPriColegioText = this.dPriColegioTable.selected[0].IdColegio + " - " + this.dPriColegioTable.selected[0].Nombre + " - " + this.dPriColegioTable.selected[0].Dpto+ "/" + this.dPriColegioTable.selected[0].Provincia+ "/" + this.dPriColegioTable.selected[0].Distrito;
                    this.dPriColegioModal.dialog = false;
                }
            }
        },
        async fuPricolegioByNombreByDpto () {
            try {
                this.dPriColegioLoading = true;
                const response = await this.$apollo.query({
                    query: gql`query pricolegioByNombreByDpto($Nombre: String!, $Dpto: String!){
                        pricolegioByNombreByDpto(Nombre: $Nombre, Dpto: $Dpto){
                            IdColegio
                            Nombre
                            Modalidad
                            TipoColegio
                            Dpto
                            Distrito
                            Provincia
                        }
                    }`,
                    variables: {
                        Nombre: this.dPriColegio.Nombre,
                        Dpto: this.dPriColegio.Dpto,
                    }
                })
                this.dPriColegios = response.data.pricolegioByNombreByDpto;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dPriColegioModal.loading = false;
            }
        },
    }
}
</script>
